var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectedworldCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 369.32,
    cy: 431.3,
    r: 24.5,
    transform: "translate(-130.3 161.48) rotate(-21.06)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.39,
    cy: 72.17,
    r: 24.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.91,
    cy: 245.32,
    r: 10.45,
    transform: "translate(-205.28 249.24) rotate(-80.75)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.09,
    cy: 246.83,
    r: 10.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.68,
    y: 172.19,
    width: 2,
    height: 151.95,
    transform: "translate(-124.66 369.46) rotate(-88.99)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.81,
    y: 236.58,
    width: 2,
    height: 211.7,
    transform: "translate(-136 224.33) rotate(-32.9)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.83,
    y: 63.28,
    width: 2,
    height: 166.62,
    transform: "translate(-48.29 89.7) rotate(-26.7)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.62,
    y: 245.83,
    width: 190.47,
    height: 2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.27,187.8l-3.55,3.52-2,2c-9.53-9.25-20.87-14.18-34.16-14.19s-24.63,4.92-34.23,14.23c-.63-.66-1.26-1.34-1.91-2q-1.74-1.77-3.5-3.52a.24.24,0,0,0-.11-.06v-.09l.26-.21c1.5-1.33,2.95-2.7,4.49-4a55.37,55.37,0,0,1,24.12-11.24c2.27-.41,4.58-.63,6.87-.91.78-.1,5.86-.11,6-.1,1.56.12,3.13.18,4.69.35a53.66,53.66,0,0,1,12.61,3,55.69,55.69,0,0,1,8.53,4,52.85,52.85,0,0,1,8.14,5.7c1.28,1.09,2.5,2.24,3.75,3.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.58,204.48,392,198.92a39.56,39.56,0,0,1,22.81-11.45c13.26-1.79,24.65,2.24,34.3,11.38l-5.63,5.6a32.45,32.45,0,0,0-45.87,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.85,210.08l-5.58,5.57a16.57,16.57,0,0,0-23.5,0l-5.57-5.57A24.36,24.36,0,0,1,437.85,210.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.56,220.72a5,5,0,1,1-5-5A5,5,0,0,1,425.56,220.72Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43,308.25a8.86,8.86,0,0,0,8.2,8.84v0h50.18a10.41,10.41,0,0,0,1-20.78,17.54,17.54,0,0,0-34-5.49,10.26,10.26,0,0,0-4.66-1.1,10.41,10.41,0,0,0-10.39,9.77,8.57,8.57,0,0,0-1.44-.12A8.86,8.86,0,0,0,43,308.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.89,
    cy: 51.17,
    r: 6.97,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.7,66.62a7,7,0,1,1-7-7A7,7,0,0,1,225.7,66.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.86,82.08a7,7,0,1,1-7-7A7,7,0,0,1,250.86,82.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.35 83.71 216.85 66.6 243.37 50.31 244.42 52.02 220.6 66.64 244.44 82.03 243.35 83.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.61,408.7c-12.05,0-21.82,7.22-21.82,16.11a12.64,12.64,0,0,0,2.17,7L267,438.39l7.52-1.92a26.15,26.15,0,0,0,15.05,4.46c12.05,0,21.81-7.21,21.81-16.12S301.66,408.7,289.61,408.7Zm-10.12,18.38a2.27,2.27,0,1,1,2.26-2.27A2.27,2.27,0,0,1,279.49,427.08Zm10.12,0a2.27,2.27,0,1,1,2.26-2.27A2.26,2.26,0,0,1,289.61,427.08Zm10.11,0a2.27,2.27,0,1,1,2.26-2.27A2.27,2.27,0,0,1,299.72,427.08Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--World--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410,250a159.29,159.29,0,0,1-30.55,94l0,0A160,160,0,1,1,250,90q6.58,0,13,.53a159.07,159.07,0,0,1,70,22.68,160.68,160.68,0,0,1,42.72,37.88A159.51,159.51,0,0,1,410,250Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.54,325.5c-2,5.38,1.35,5.6,1.57,7.84s0,6.5-6.5,13-17.25,5.15-19.49,7.84-6.05,14.11-11.42,17.92-6.28,1.57-13.89,3.14-13.45,11.43-15.69,16.13.45,12.55-4.93,12.77-7.84-11.43-12.77-17.7-6.49-11.87-8.06-19.27.89-22.85,0-28.9-17-16.8-22.85-24.19S156.62,291.9,157.06,287a20.13,20.13,0,0,1,6.72-12.33c2.69-2,1.57-3.13,2-4.92s2.69-2.24,3.14-4.49-1.35-9-3.59-10.08-3.81,2.69-5.15,2-5.38-5.38-6.95-5.83-1.12,2.92-3.36-1.34-3.36-15-5.15-16.8-3.14,3.13-7.39,0-6-9.19-7.84-10.08-4.26.22-6.1-3.37,1.62-10.08,0-9.41-5.11,5.83-6,.9,4.48-21.51,3.58-30.47,2.24-18.37,8.52-26c0,0,.89-4.93,1.79-8.06s20.16-15.69,22.4-19.27c.94-1.5,1.25-3.85,1.58-6.37A159.22,159.22,0,0,1,250,90q6.58,0,13,.53l.45.6c1.94,2.46,4,4,9.71,6.12s7,4.78,5.83,7-3.14,2.69-5.38,2.84-4.33-1-6.72.45-4.78,9.55-7.92,10-8.66-7.17-9.86-9.41,2.69-7,.86-9.26-5-1.79-10.12-2.24-16.87,1.5-16.42,3.44,17.32-.3,17.77,3.58-12.4,10.46-14.64,9.86-5.23-4.48-8.51-4.93-6,2.24-8,2.54-4.51-2.24-7.64-1.64-3.89,3.28-5.53,4.33-5.53,1-6,3.43,4.93,3.74,6.28,5.23-1.65,6.57-.3,7.62,9.71-6.28,11.8-8.07,3.88-9.55,8.36-9.41,6,7.77,7.47,8.52,4.78-1.8,9.71-.75,8.36,11.8,9.26,15.09,3,6.57,1.19,7.91-9.85-.89-10.9-3,5.38-5.23,4.93-6-4.18-1.79-6.12-.62-2.84,3.61-4.93,4.21-7.62-5.68-9.11-3.89,1.49,7.47,3,8.81,7,2.09,7.47,3.59-3.73,4.78-8.81,4.48-9.26-4.19-11.21-2.54-.89,6-2.24,7.47-8.66.45-12.24,4.33-5.23,9.71-8.82,13-5.22-.89-10,3.74S170.13,192,170,195.56s0,6.42-1.19,6S166,198,165.5,196s1.05-5.23,1.05-6.42-6.87-7.33-10.91-7.92-7.61,2.69-10.6,5.07-8.36,1.95-10.3,3.89-3.44,19.12-2,23.15,3.44,4,8.22,1.94,2.09-6.12,4.93-5.23a6.7,6.7,0,0,1,4.33,6.28c0,2.39-5.68,8.06-4.93,9.71s5.67-.3,8.06.44,3.59,2.24,2.84,8.37-.3,10.9,3.29,12.92,5.6-2.91,7.17-2.24,3.81,4.25,6.05,4,1.12-2.24,5.37-3.58,2.69-2.24,3.59-4.93,3.58-4.93,6.5-3.59.89,3.36,1.12,5.6,5.37,2.47,9.41,3.81,6.27,0,14.33,2.69,8.52,10.75,11.88,12.1,14.56-.9,22.63,4.93,5.82,16.58,9.85,19.71,19.05,7.4,24.87,8.52,6.72-2.92,11.43-1.8,7.39,2.47,9,9C304.07,308.14,286.56,320.12,284.54,325.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.16,210.94c.15,1.27,3.88,1.79,8.36,4.33s6.13,10,8.52,9.86,1.64-3.58,2.53-4.48,2.39-2.84,0-4.78-4.71-6.12-9.07-6.72-5.11-2.39-7.06-2.24A3.37,3.37,0,0,0,164.16,210.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.8,223.49c-.66,1.83,0,3.14,4.78,4.33s9.26-1.19,7.77-2.17-3.74-.52-2.84-2.16.59-4-3.29-3.59S189.4,221.85,188.8,223.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.53,224c-1.63.23-2.54,3.07-.9,4.87s1.65,1.49,3.59,0,4.93-2.24,4.18-3.74S207.17,223.76,205.53,224Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.53,230.1c.73-2.24,4.48,0,6.12,2.35s.9,5.83,0,8.36-1.49,5.53-3.59,4.34.15-4.78-.14-6.87S217.93,231.93,218.53,230.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.9,105.49c-.78,1.88,2.84,2.54,4.93,3.74s3.73,1.94,4.93,0-.45-4.18-2.09-4.63S283.65,103.7,282.9,105.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M311.13,123c1.38,1.45,3.73,1.19,5.38,3.28s1,5.68,3.13,6.73,3.59,0,3.74-1.5-3-5.23-2.69-6,4.33,1,5.23,3.28-.9,5.38,1.19,6,1.64-2.09,2.54-2.69,2.84-.3,2.69-2.09-2.54-5.68-4.48-7-3.44-2.84-6.72-3.59-6.43-.15-8.07,1.2S310.28,122.07,311.13,123Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M375.75,151.12a2.66,2.66,0,0,1-.84,1.57c-3.14,2.24-6.88-5.52-11.2-7s-6.28-7-7.17-5.82-.6,2.83-2,4.77-3.28,1.5-4.18,5.23,4.18,10.61,3,12.85-2.69,1.49-5.08,1.34-1.94,1.94-5.07,1.05-.46-4.78-5.39-9.41-6.57-5.53-5.52-7.62-.45-5.08,1.79-5.38,4,3,5.53,3.89,3.43-1.79,3.58-4.19-5.23-5.67-7.17-7.52-2.09-8.61-1.34-10,3-.9,3.58-4.18c.35-1.93-2.7-5.16-5.28-7.49A160.68,160.68,0,0,1,375.75,151.12Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M398.06,285c.44-4.78-1.94-5.08.44-13.89S396,252.91,394.17,251s-5.67-1.34-8.81.6-.89,3.43-3,4.18-4.18-.45-6.12-.3-3.74,5.08-7.92,4.93-6.87-6.12-10-10.38-9.56-6.95-11.65-12.17,1.94-13.29,1-19.42-4.93-4.78-5.67-8.21.6-1.8,1.64-5.08-1.2-5.08.9-10.76,5.82-8.51,4.92-11.05-3.73-6.72-3.88-9.7,2.84-2.84,8.51-7,7.17-3.88,11.51-2.39a62.58,62.58,0,0,0,9.55,2.69c2.54.45,6,7,7,6.72s1.2-2.24,1.65-5.07a6.29,6.29,0,0,1,1.86-3.22A160,160,0,0,1,379.42,344C394.65,320.78,397.61,289.8,398.06,285Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M373.93,351.15A160,160,0,1,1,250,90q6.58,0,13,.53c1.19.09,2.38.2,3.56.33A146.58,146.58,0,1,0,373.93,351.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,250a159.14,159.14,0,0,1-30.56,94v0A160.74,160.74,0,0,1,322,392.91a161.86,161.86,0,0,0,50.45-45.2l0,0A160.89,160.89,0,0,0,255.36,92.73c-4.32-.35-8.7-.53-13.11-.53a161.26,161.26,0,0,0-38.63,4.67A159.92,159.92,0,0,1,250,90q6.58,0,13,.53A159.93,159.93,0,0,1,410,250Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.46,
    cy: 362.88,
    r: 58.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.46,422.36A59.48,59.48,0,1,1,451,362.88,59.55,59.55,0,0,1,391.46,422.36Zm0-118A58.48,58.48,0,1,0,450,362.88,58.55,58.55,0,0,0,391.46,304.4Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.46,430.5a67.62,67.62,0,1,1,67.63-67.62A67.7,67.7,0,0,1,391.46,430.5Zm0-133.24a65.62,65.62,0,1,0,65.63,65.62A65.7,65.7,0,0,0,391.46,297.26Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.32,311.89a4.87,4.87,0,0,1,1.58,1c2.08,2,2.35,5,2.08,7.71-.31,2.87-1.3,5.87-.63,8.75a4.83,4.83,0,0,0,1.75,2.9,4.4,4.4,0,0,0,3.63.43c1.3-.29,2.77-.93,4.08-.35a3.73,3.73,0,0,1,1.93,2.76c.6,2.9-1.36,5.66-1.92,8.42a15,15,0,0,0,.9,8.81,14.83,14.83,0,0,0,9,8.15c1.46.44,3,.57,4.48.95a5.27,5.27,0,0,1,3.54,2.36c.53,1,.21,5.26-3.25,9.15-.24.28.27.7.63.51a18.74,18.74,0,0,0,2-1.19,20.06,20.06,0,0,0,8.64-16.08,20.82,20.82,0,0,0-2.34-9.82,33.57,33.57,0,0,1-2.46-5.13,10.45,10.45,0,0,1-.24-4.94c.54-3.15,1.83-6.14,1.82-9.39a17.61,17.61,0,0,0-2.23-8.29,20.78,20.78,0,0,0-14-10.18C414.52,307.2,401,311.76,401.32,311.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,312a8.07,8.07,0,0,1,2.88,2.3,6.66,6.66,0,0,1,1.16,3.13c.32,2.5-.41,4.9-1.06,7.3-.6,2.24-1.13,4.66-.31,6.92a5.47,5.47,0,0,0,1.74,2.51,4.29,4.29,0,0,0,3.19.75c2.07-.24,4.61-1.21,6.37.45s1.11,4.38.69,6.38c-1,4.89-3.05,11.08.75,15.34a18.47,18.47,0,0,0,7.49,4.55c1.93.7,4.38,1.57,5.12,3.69,0,.07-.09.1-.12,0-.83-2.23-3.43-2.67-5.44-3.3a19.5,19.5,0,0,1-6.6-3.45,9.55,9.55,0,0,1-3.34-6.39,22.32,22.32,0,0,1,.74-7.58c.29-1.28.61-2.54.87-3.83a8.19,8.19,0,0,0,.13-3.55,2.8,2.8,0,0,0-2.53-2.13,14.38,14.38,0,0,0-3.63.4,5.65,5.65,0,0,1-3.18-.31,5.11,5.11,0,0,1-2-1.69,8,8,0,0,1-1.29-5.69c.33-2.81,1.59-5.42,1.87-8.23a6.66,6.66,0,0,0-3.67-7.33A.16.16,0,0,1,401.5,312Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.64,307.14c5.94,1.14,10.62,5.87,12.49,11.51a20.86,20.86,0,0,1,.7,9.8c-.47,3.06-1.37,6.12-1.17,9.24.22,3.46,2.3,6.18,3.91,9.11a18.8,18.8,0,0,1,2.28,7.67,19.92,19.92,0,0,1-4.8,14.4,18.63,18.63,0,0,1-1.38,1.43c-.06.06-.14,0-.08-.09a19.17,19.17,0,0,0,5.62-14.09,18.72,18.72,0,0,0-1.63-7.41c-1.3-2.88-3.44-5.33-4.36-8.39-.86-2.86-.36-5.88.21-8.75.62-3.13,1.22-6.22.76-9.42a17,17,0,0,0-10.31-13.58c-6.32-2.49-13.11-.54-19.08,2l-2.39,1c-.09,0-.16-.09-.07-.13C409.28,308.57,415.91,305.84,422.64,307.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,308.58a2.9,2.9,0,0,1,2.87,0c.47.5.91,5.83,0,6.8s-2.93-.45-2.93-.45Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.49,352.51c-25.27,22.77-48.69,47.71-50.52,60.43-2.54,17.63,8.3,22.51,13.15,22.56,13.23.13,37.25-53.45,45.61-73.91C390.84,341.72,380,347.51,374.49,352.51Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,389l28.09,15.27S381.91,372,385.93,357s-2-14.52-15.2-2.89S336.35,389,336.35,389Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,389l28.09,15.27S381.91,372,385.93,357s-2-14.52-15.2-2.89S336.35,389,336.35,389Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.93,357c-4,15-21.49,47.23-21.49,47.23l-25.58-13.91L386,346C387.54,347.25,387.61,350.8,385.93,357Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.14,384.65C353,392,363.46,396.74,365.57,398c.1.06.18-.11.07-.16-2.12-1.08-13.65-8.26-23.42-13.32C342.11,384.41,342,384.58,342.14,384.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.53,410.31q-1.89,1.41-3.9,2.65-1,.63-2,1.2a57.9,57.9,0,0,1-6.47,3.18q-1.54.65-3.15,1.2a58.12,58.12,0,0,1-15.67,3.19c-1.28.09-2.57.13-3.87.13s-2.59,0-3.87-.13a58.5,58.5,0,0,1-15.67-3.19c-1.06-.37-2.11-.77-3.14-1.2a57.9,57.9,0,0,1-6.47-3.18q-1-.57-2-1.2h-.89l.08-.51.42-2.68.19-1.2.5-3.19.1-.66s-.11-.18-.29-.53c-.33-.62-.89-1.74-1.49-3.2l-.24-.58c-.08-.19-.16-.4-.24-.61-.37-1-.75-2-1.08-3.19a.14.14,0,0,1,0-.06,4.61,4.61,0,0,1-.15-.53c-.06-.2-.11-.4-.16-.6h0a31.77,31.77,0,0,1-.68-3.2c-.06-.39-.11-.79-.15-1.19a22.58,22.58,0,0,1-.12-3.19,1.21,1.21,0,0,1,0-.19v0c0-.25,0-.51.05-.76,0-.06,0-.13,0-.19a15.88,15.88,0,0,1,.62-3.2,5.43,5.43,0,0,1,.17-.53.49.49,0,0,1,0-.11c.06-.18.14-.37.21-.55h0c.08-.21.15-.42.25-.63.27-.6.74-1.47,1.38-2.56l.05-.09.65-1.11c.57-1,1.23-2,2-3.19.17-.27.34-.54.52-.81l.24-.38c.65-1,1.35-2.09,2.08-3.19l.8-1.2c.71-1,1.44-2.11,2.19-3.19.28-.39.55-.79.83-1.19h0c.75-1.07,1.52-2.15,2.3-3.2h0l.21-.29q.31-.45.66-.9h0c.81-1.09,1.62-2.16,2.44-3.19.14-.19.29-.37.43-.55l.51-.64c.9-1.12,1.8-2.2,2.67-3.2l.64-.73a50.2,50.2,0,0,1,3.58-3.65c.48-.45.95-.84,1.4-1.19a5.15,5.15,0,0,1,.48-.37c5.36-3.88,12.64-2.49,17.86.37h0l.18.1c.28.15.56.31.82.48l.15.09c.24.15.48.3.71.46l.08.06h0a15,15,0,0,1,3.48,3.19h0l.07.09.8,1.1c.76,1.06,1.5,2.12,2.2,3.2h0c.27.39.52.79.77,1.19.67,1,1.31,2.1,1.93,3.19.16.29.33.58.49.88l.17.31c.56,1,1.11,2.1,1.64,3.2.17.34.34.7.49,1,0,0,0,.05,0,.07s0,0,0,.07h0c.47,1,.93,2.09,1.38,3.19l.33.85c.05.11.09.23.14.35.4,1,.78,2.08,1.16,3.19h0c.14.38.27.79.4,1.19.34,1,.67,2.08,1,3.19.12.39.23.79.35,1.2.3,1,.59,2.09.87,3.19q.13.47.24.93a2.5,2.5,0,0,1,.07.26c.26,1,.52,2.1.77,3.2.1.39.19.79.28,1.19.23,1,.46,2.09.69,3.19.08.39.16.79.25,1.19.21,1,.42,2.1.63,3.2.07.39.15.79.23,1.19.19,1,.38,2.1.57,3.19L425,401c.18,1,.36,2.11.53,3.2,0,.1,0,.19.05.29.05.3.09.6.14.9.17,1,.34,2.1.5,3.19.07.4.13.79.19,1.2C426.48,410,426.5,410.13,426.53,410.31Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.24,348.31c-.23-.16-.47-.31-.71-.46l-.15-.09c-.26-.17-.54-.33-.82-.48l-.18-.1H383c-.45.35-.92.74-1.4,1.19h21.69Zm3.65,3.34-.07-.09H378.48l-.43.46-.64.73h30.28Zm3,4.3H374.74l-.51.64-.44.55h36.88C410.42,356.74,410.17,356.34,409.9,356Zm3.19,5.26c-.16-.3-.33-.59-.49-.88H371.35q-.35.45-.66.9l-.22.29h42.8Zm2.33,4.63s0,0,0-.07c-.15-.35-.32-.71-.49-1H368.16c-.28.4-.55.8-.83,1.19h48.13A.16.16,0,0,0,415.42,365.84Zm1.75,4.11-.33-.85h-51.7l-.8,1.2h53C417.26,370.18,417.22,370.06,417.17,370Zm1.31,3.54H362.26l-.24.38c-.18.27-.35.54-.52.81h57.38C418.75,374.28,418.62,373.87,418.48,373.49Zm1.41,4.38H359.54l-.65,1.11-.05.09h61.4C420.12,378.66,420,378.26,419.89,377.87Zm1.45,5.32c-.07-.31-.15-.63-.23-.93H357.2c-.07.18-.15.37-.21.55a.49.49,0,0,0,0,.11,5.43,5.43,0,0,0-.17.53h64.63A2.5,2.5,0,0,0,421.34,383.19Zm.84,3.46h-66c0,.06,0,.13,0,.19,0,.25,0,.51-.05.76v0c0,.06,0,.13,0,.19h66.38C422.37,387.44,422.28,387,422.18,386.65Zm1,4.38H356.21c0,.4.09.8.15,1.19h67C423.31,391.82,423.23,391.42,423.15,391Zm.88,4.39H357c.05.2.1.4.16.6a4.61,4.61,0,0,0,.15.53.13.13,0,0,0,0,.06h66.91C424.18,396.21,424.1,395.81,424,395.42Zm.8,4.38H358.44c.08.21.16.42.24.61l.24.58H425Zm.79,4.68c0-.1,0-.19-.05-.29H360.41c.18.35.29.53.29.53l-.1.66h65.16C425.71,405.08,425.67,404.78,425.62,404.48Zm.64,4.09H360.1l-.19,1.2h66.54C426.39,409.36,426.33,409,426.26,408.57Zm-66,4.39q1,.63,2,1.2h58.31q1-.57,2-1.2Zm8.48,4.38c1,.43,2.08.83,3.14,1.2H411q1.61-.56,3.15-1.2Zm18.81,4.39c1.28.09,2.57.13,3.87.13s2.59,0,3.87-.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.31,401.1a73.34,73.34,0,0,1,10.61,1.84c1.73.46,3.42,1,5.12,1.57.84.29,1.69.54,2.54.8a11.49,11.49,0,0,0,2.73.54.06.06,0,0,1,0,.12,19.4,19.4,0,0,1-2.64-.07,18.24,18.24,0,0,1-2.51-.49c-1.75-.45-3.49-1-5.24-1.45-3.53-.94-7.06-1.88-10.66-2.56C374.1,401.36,374.14,401.08,374.31,401.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.44,404.19a77.37,77.37,0,0,1,8.88-.34c1.48,0,2.95.14,4.43.3.7.07,1.41.16,2.11.26s1.53.31,2.3.4c.08,0,.08.14,0,.13-.73-.06-1.48,0-2.21,0l-2.22-.08c-1.48-.05-3-.08-4.43-.15-3-.12-5.91-.22-8.87-.24C365.27,404.44,365.28,404.21,365.44,404.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.77,350.89c24,18.39,48.93,49.61,49.3,67.63.37,17.8-9.62,16-11.31,15.5-17.8-5.54-39.25-54.91-47.19-75C391.69,339,402.84,346.34,408.77,350.89Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.25,386.77l-27.81,15.77s-18-32-22.33-46.83,1.73-14.55,15.15-3.16S447.25,386.77,447.25,386.77Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.4,382.57c-10.7,7.51-21.11,12.47-23.19,13.71-.1.06-.19-.1-.08-.16,2.1-1.11,13.5-8.5,23.18-13.73C441.42,382.33,441.5,382.49,441.4,382.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.23,401.45a16.61,16.61,0,0,0-1.68.75c-2.67-5.32-2.19-4.1-4.91-9.39-1.33-2.59-2.67-5.18-4-7.78s-2.62-5.51-4.15-8.12c0-.08-.15,0-.12.06.89,2.55,2.09,5,3.22,7.49-.25-.38-.49-.77-.76-1.14-.62-.82-1.22-1.65-1.76-2.52-.09-.14-.31,0-.22.11.52.83,1,1.69,1.43,2.56s1,1.7,1.48,2.53,1.05,1.58,1.6,2.35l.21.28c.72,1.54,1.43,3.09,2.19,4.62a72.57,72.57,0,0,0,5.53,9.52,14.07,14.07,0,0,0,2-1.17C421.38,401.54,421.3,401.44,421.23,401.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.35,434.88c8.24-1.21,12.91-16.53,22.06-40.91,1.61-4.28-19.68-28.79-22.57-24.85-3.64,5-13.29,32.5-14.25,40C321.69,423.86,328.72,436.29,338.35,434.88Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,418.64c.65-2.11,1.4-4.18,2.15-6.25s1.56-4.12,2.35-6.17,1.63-4.08,2.47-6.11c.43-1,.85-2,1.25-3.06s.82-2,1.16-3.08a37.9,37.9,0,0,1-1.68,6.4c-.68,2.1-1.47,4.16-2.27,6.22s-1.65,4.08-2.57,6.09S352.06,416.69,351,418.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.12,386.8c1.16-8.37,3.52-20,6.51-22.49s14.54-11.15,17.83-12.29,18-6.73,20.67-5.17c2.16,1.25-.4,6.93-7.38,9.65-6.14,2.39-9.3,4.62-11.06,5.38s-6.09,6.57-4.92,9.14c.7,1.51,5.1,3.29,7.83,2.05s3.41-6.65,6.54-9.21,8.64-2.24,8.95-.76-1.5,2.19-4.32,7.25c-1.81,3.25-1.93,11.06-6,16.66-2.06,2.81-5.66,10.3-5.66,10.3Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.05,361.55a5.49,5.49,0,0,0,2.74-1.23,2.3,2.3,0,0,0,.62-1.12,2.35,2.35,0,0,0,0-.7,1.08,1.08,0,0,0-.27-.67c-.05,0,0-.1.06-.05a2,2,0,0,0,.25.33,1.87,1.87,0,0,1,.15.32,1.6,1.6,0,0,1,.12.68,2.29,2.29,0,0,1-.54,1.39,3.77,3.77,0,0,1-3.14,1.14A0,0,0,0,1,370.05,361.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.63,364.31c2.66-4.18,9.46-11.71,16.2-14.3,4.56-1.75,20.25,5.87,19.79,8.87s-3.13,3-7.1,2.54c-1.44-.17-9.09-2.91-10.39-1.3-1.87,2.3-4.24,10.18-4.24,10.18Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.24,357.71c-1.94-3.21-6.21-4.92-10.44-6.27a.06.06,0,0,0,0,.11c1.08.34,8,3.51,10.43,6.21C373.22,357.79,373.25,357.74,373.24,357.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.63,364.31c2.66-4.18,9.46-11.71,16.2-14.3,4.56-1.75,17,8,16.52,11s-4.3,3.24-8.56,1.76c-1.37-.48-6-3.72-7.29-2.11-1.87,2.3-6.43,8-6.43,8Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.7,365.15c.43-.66.57-.89,1-1.54s.89-1.29,1.37-1.91a6,6,0,0,1,1.4-1.48,3,3,0,0,1,1.88-.37,10.73,10.73,0,0,1,4.07,1.78c1.39.81,4.29,2.1,6.51,1.87a4.44,4.44,0,0,0,1.75-.48,2.74,2.74,0,0,0,1.05-.84c1-1.63-.24-3.49-1.47-4.81a28.45,28.45,0,0,0-8.37-5.71c-.73-.36-1.48-.7-2.22-1a6.5,6.5,0,0,0-2.69-.76c-1.54,0-4.07,1.55-4.85,2-.06,0-.11-.06-.05-.1,1-.59,3.3-2.52,5.78-2.39a7.56,7.56,0,0,1,2.59.87c.87.37,1.73.77,2.57,1.2a34.82,34.82,0,0,1,4.75,2.8,14.86,14.86,0,0,1,3.88,3.66,4.33,4.33,0,0,1,.27,4.44,3.79,3.79,0,0,1-2.79,1.49,7.22,7.22,0,0,1-2,0,31,31,0,0,1-4.26-1.24c-1.35-.54-2.57-1.45-4-1.86a2.6,2.6,0,0,0-2,.13,6.74,6.74,0,0,0-1.5,1.37,21.64,21.64,0,0,0-2.51,3C350.73,365.52,350.52,365.43,350.7,365.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.66,368c1-2,2.62-10.18,4.2-12.69s8.79-11.21,12.16-10.83c4.24.47-.17,8.1-2.39,11.25s-1.84,8.49-1.84,8.49Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.72,350.47a37.77,37.77,0,0,0-2.17,3.17,24.21,24.21,0,0,0-1.89,3.12,11,11,0,0,0-.83,3.49c-.05.59-.07,1.18-.07,1.77s.05,1.29,0,1.94a.06.06,0,0,0,.11,0,26.06,26.06,0,0,1,.45-3.52,15.29,15.29,0,0,1,1.06-3.49c1-2.22,2.44-4.2,3.45-6.41C352.91,350.46,352.78,350.4,352.72,350.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.85,365.07a10.43,10.43,0,0,0,.72,2.87,26,26,0,0,0,1.19,2.7,27.74,27.74,0,0,0,3.17,4.95,18.78,18.78,0,0,1,3,5.31,16.12,16.12,0,0,1,.84,6,20.42,20.42,0,0,0-4.61-10.69,23.94,23.94,0,0,1-1.76-2.48A23.21,23.21,0,0,1,349,371,12.47,12.47,0,0,1,347.85,365.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.55,357.59l11.59,34.61c.46,1,0,1.89-1,2l-18.21,1.39a2.93,2.93,0,0,1-2.67-1.68l-11.6-34.61c-.46-1,0-1.89,1-2l18.21-1.4A3,3,0,0,1,380.55,357.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.38,357.74,390,392.35a1.26,1.26,0,0,1-1,2l-18.21,1.4a3,3,0,0,1-2.67-1.68l-11.59-34.61c-.46-1,0-1.89,1-2l18.21-1.39A2.93,2.93,0,0,1,378.38,357.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.51,359.74a1.55,1.55,0,0,0,3.09-.31,1.55,1.55,0,0,0-3.09.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.54,434.21c-7.94,1.18-17.93-4.89-43.86-23.38-3.59-2.56,7.66-32.74,11.63-30.2,5,3.19,23.73,16.67,25,17.82C453.78,408.22,455.93,433.4,450.54,434.21Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.6,389.61s-7.44-10.19-13-14.34c-7.45-5.56-16.17-7.28-19.87-7.78-7.72-1.05-27.12,1.75-27.29,7.48-.15,5.18,19.53,1.31,19.53,1.31s-20.71.63-19.75,6.91,23.56.49,23.56.49-21.27,1.12-19.25,7.44c1.52,4.77,22.28.68,22.28.68s-18.28,1.09-16.92,6.07c1.5,5.49,20.89,2.92,20.89,2.92,5.58,12.06,13.17,15.53,18.87,17.35C418,418.58,427.6,389.61,427.6,389.61Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.11,375.61c-2.43,0-4.9-.05-7.33.15s-4.85.49-7.25.92a41.24,41.24,0,0,0-9.18,2.56c5.4-1.75,14.08-2.61,16.51-2.81s4.84-.53,7.26-.73A0,0,0,0,0,394.11,375.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,384.36c-3.11.12-6.2.12-9.31.38s-6,.76-9.07,1.23c-.23,0-.14.15.1.12,3.08-.34,6-.42,9-.73s6.16-.73,9.24-.92A0,0,0,0,0,395,384.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.12,391.74a70,70,0,0,0-14.2,1.66c-.23.05-.09.18.15.15,4.71-.64,8.4-1.18,14.05-1.64C397.21,391.9,397.22,391.74,397.12,391.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.12,393.12a65.28,65.28,0,0,1,6.07,4.24c1,.76,1.91,1.57,2.82,2.43a14.8,14.8,0,0,1,2.42,2.92,34.89,34.89,0,0,1,3.17,6.75,30.33,30.33,0,0,1,1.71,7.2c-.32-1.19-.67-2.36-1.1-3.51s-.84-2.3-1.33-3.42a48.1,48.1,0,0,0-3.3-6.48,14.24,14.24,0,0,0-2.23-2.79c-.84-.87-1.76-1.68-2.66-2.51s-1.83-1.62-2.77-2.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.3,347.38c-.18,1.36-5.68,10.75-13.12,10.38-4.32-.21-1.47-8.86-1.47-8.86l-3.87-11.75,14.13-11S399.37,346.8,399.3,347.38Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.58,333.84a23.61,23.61,0,0,1-12.09,14.41l-3.65-11.09L395,326.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.85,320.79c-.19,20.25,11.92,22.66,16.29,22.7,4,0,17.47-.36,19.76-20.48s-7.07-26.63-16.14-27.19S364.05,300.53,363.85,320.79Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.83,319.2a10.87,10.87,0,0,0,1.34-.41,2.28,2.28,0,0,0,1.28-.67.72.72,0,0,0-.08-.88,1.79,1.79,0,0,0-1.79-.26,2.65,2.65,0,0,0-1.56,1.07A.77.77,0,0,0,368.83,319.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.66,318.71a12.85,12.85,0,0,1-1.39-.16,2.25,2.25,0,0,1-1.38-.44.72.72,0,0,1-.08-.88,1.79,1.79,0,0,1,1.72-.57,2.6,2.6,0,0,1,1.72.78A.76.76,0,0,1,382.66,318.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.23,323.31c0-.05.11.06.12.12,0,1.38.33,2.95,1.6,3.32,0,0,0,.08,0,.08C380.41,326.72,380.05,324.63,380.23,323.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.37,321.79c2.2-.31,2.66,4.12.62,4.41S379.52,322.06,381.37,321.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.26,321.94c.41.21.84.61,1.31.61s.9-.51,1.21-1c0-.05.07,0,.08.05.1.84-.13,1.75-1,2s-1.49-.49-1.79-1.32C382,322.1,382.09,321.85,382.26,321.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.94,324c0-.06-.1.07-.09.13.2,1.36.19,3-1,3.56,0,0,0,.09,0,.07C372.37,327.38,372.35,325.26,371.94,324Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.55,322.7c-2.22.08-1.89,4.53.17,4.45S372.42,322.63,370.55,322.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.65,323.06c-.33.26-.65.72-1.07.78s-.88-.39-1.22-.83c0,0-.07,0-.07.06,0,.85.39,1.71,1.22,1.81s1.25-.67,1.39-1.53C369.92,323.19,369.78,323,369.65,323.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.44,334.32c-.27.37-.53.86-1,1a3.73,3.73,0,0,1-1.52-.12,0,0,0,0,0,0,.08,1.84,1.84,0,0,0,1.84.47,1.44,1.44,0,0,0,.89-1.36C380.59,334.28,380.48,334.27,380.44,334.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.24,329.89s-.09,2.08,0,3.05c0,.09.24.11.57.1h0a4.65,4.65,0,0,0,4.31-2.14c.06-.1-.08-.19-.16-.12a7,7,0,0,1-4.09,1.6c-.09-.26.28-3.56.12-3.55a8.39,8.39,0,0,0-2.15.7c.07-4.34.83-8.62.83-12.94a.13.13,0,0,0-.26,0c-1.11,4.44-1.3,9.43-1.48,13.9C371.94,331,373.86,330.09,374.24,329.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.41,332.46a5,5,0,0,0,2.07,1.44,2.25,2.25,0,0,0,1.36,0c1-.31,1-1.21.73-2a5.7,5.7,0,0,0-.5-1.16A6.41,6.41,0,0,1,375.41,332.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.48,333.9a2.25,2.25,0,0,0,1.36,0c1-.31,1-1.21.73-2A2.32,2.32,0,0,0,377.48,333.9Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.33,323.76c-3.69.92-5.65-5.52-5.65-5.52s-16.17.58-19.05-12.24c0,0-1.75,9-9.75,11.9,0,0-1.11-16.31,9.84-20.39,0,0,13.4-6.74,22.58,3.44S400.8,323.15,398.33,323.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.7,305.84a14.16,14.16,0,0,0,2,5.67A14.94,14.94,0,0,0,379.8,316a12.25,12.25,0,0,0,1.29.82l.66.39.7.32c.47.19.93.41,1.41.59l1.46.41c.25.06.49.14.74.19l.75.12,1.49.22c1,.05,2,.05,3,0-1-.2-2-.28-2.94-.48l-1.44-.35-.72-.16-.69-.25-1.38-.49c-.45-.19-.88-.41-1.32-.62l-.66-.31-.61-.38a11.14,11.14,0,0,1-1.22-.8,17.09,17.09,0,0,1-4.05-4.13,18.93,18.93,0,0,1-2.58-5.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.46,323.15s3.92-6.64,6.91-5.29.37,10.74-2.9,12.25a3.41,3.41,0,0,1-4.71-1.48Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.55,320.53c.05,0,.07.07,0,.09-2.28,1.14-3.35,3.41-4,5.75a1.89,1.89,0,0,1,2.78-.74c.06,0,0,.14-.05.13a2.11,2.11,0,0,0-2.26.91,10.17,10.17,0,0,0-1,2c-.1.22-.49.14-.43-.11a.14.14,0,0,0,0-.06C397.34,325.46,399.35,321.08,402.55,320.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.8,
    y: 283.39,
    width: 2,
    height: 44.2,
    transform: "translate(-117.65 362.92) rotate(-50.74)",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 136.27,
    cy: 391.14,
    r: 58.98,
    transform: "translate(-273.71 450.14) rotate(-78.98)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.27,450.62a59.48,59.48,0,1,1,59.48-59.48A59.54,59.54,0,0,1,136.27,450.62Zm0-118a58.48,58.48,0,1,0,58.48,58.48A58.55,58.55,0,0,0,136.27,332.66Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.27,458.77a67.63,67.63,0,1,1,67.62-67.63A67.7,67.7,0,0,1,136.27,458.77Zm0-133.25a65.63,65.63,0,1,0,65.62,65.62A65.69,65.69,0,0,0,136.27,325.52Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.42,364.81c1.74,9.78,7.59,53.27,16,57.22,13.71,6.44,18.08,6.21,29.47,8.3,6.44,1.17,14-33,8-32.65-9.61.56-18.08.71-20.54.29-2.29-.41-10.94-24.94-21-38.13C148.25,348,144.19,357.91,145.42,364.81Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.69,429.31a93.77,93.77,0,0,0,12.82,3.38c3.44.48,13.36,1.58,14.27-2.15.61-2.54-5.15-3.88-9.2-4.92-2.14-.54-4.92-2.29-4.52-3.67.71-2.42,6.22-.9,9.92.59,7.15,2.87,16.93,8.49,20.47,4.57,1.34-1.49-.76-3.54-3.68-5.42,4.58,2,9.37,3.53,10.92,1.94.89-.9.78-2,.05-3.07a3,3,0,0,0,3.17-1c1.15-1.63.18-3.64-1.62-5.58a1.66,1.66,0,0,0,1.12-1c2.25-4.82-14-15.36-19.21-15.82-15.21-1.36-30.62,1.54-30.62,1.54C186.48,404.18,187.68,429.3,187.69,429.31Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.35,412.63A25.25,25.25,0,0,1,217.71,415c4.09,1.92,7,4.45,10.53,6.89.09.07,0,.21-.1.15-1.69-1.16-8.62-5.45-10.39-6.4a24.13,24.13,0,0,0-10.4-2.93S207.32,412.63,207.35,412.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.19,406a60.33,60.33,0,0,1,12,2.3c4.21,1.43,7.76,4.25,11.23,6.95,2.09,1.62,4.15,3.29,6.16,5,.08.07,0,.22-.1.15q-5.31-4.2-10.85-8.07a31.62,31.62,0,0,0-11.37-5.05c-2.33-.52-4.7-.87-7.06-1.21A0,0,0,1,1,209.19,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.53,399.94c3.86.22,7.24.41,10.85,1.94,4.79,2,9.69,5.9,11.42,7.27,1.9,1.52,3.75,3.1,5.57,4.71.08.06,0,.2-.11.13a126.1,126.1,0,0,0-13.1-9.68,25.25,25.25,0,0,0-7-3.24,46.63,46.63,0,0,0-7.63-1.11S212.51,399.94,212.53,399.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.05,395.58,151.51,420s-7.57-39-7.71-55.82c-.15-17.49,6.3-21.69,17.94-1.66A361.24,361.24,0,0,1,179.05,395.58Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.12,411.52c.63-.69,1.36-1.29,2-1.91l2.12-1.93c1.42-1.31,2.87-2.59,4.33-3.86,2.91-2.55,5.81-5.1,8.76-7.6.81-.69,1.63-1.37,2.45-2s1.8-1.33,2.67-2c0,0,.11,0,.06.09-.7.65-1.35,1.36-2.05,2s-1.44,1.34-2.17,2c-1.45,1.29-2.9,2.56-4.36,3.83-2.89,2.48-5.76,5-8.7,7.4l-2.46,2c-.86.71-1.7,1.48-2.61,2.1C152.15,411.63,152.08,411.56,152.12,411.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8,364.12c.14,16.79,7.7,55.83,7.7,55.83l23.07-20.41-25.16-50.37C145.67,348.81,143.71,354.43,143.8,364.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.19,435.46a58.94,58.94,0,0,1-77.56.23c8.23-26.52,25.31-76.16,35.47-84.27a9.33,9.33,0,0,1,2.83-1.39l.13,0a23.06,23.06,0,0,1,3.86-.79c5-.62,10.9,0,12.68,2.35C158.75,359.58,169.9,408.87,175.19,435.46Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.53,368.34c-11.72,19.37-28,49.45-23.37,65.49,4.42,15.44,73.12,13.25,84.75,11.59,5-.71-.67-35.42-6.08-35-8.93.62-44.38-1-45-1,0,0,2.55-20.54,6.72-38.41C142.18,346.68,130.18,350.75,119.53,368.34Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.79,409.45l-3.8,2c-1.26.66-2.51,1.32-3.75,2s-2.48,1.39-3.71,2.1-2.42,1.48-3.66,2.21a34.9,34.9,0,0,1,7-5,42.86,42.86,0,0,1,3.86-1.87A31.5,31.5,0,0,1,129.79,409.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.13,
    y: 427.98,
    width: 78.41,
    height: 3.51,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.54 427.98 213.54 431.49 160.24 431.49 162.93 427.98 213.54 427.98",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.02 431.5 239.64 431.5 249.57 383.08 180.95 383.08 171.02 431.5",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.23 431.5 242.85 431.5 252.78 383.08 184.16 383.08 174.23 431.5",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.69,405.48a4.84,4.84,0,0,1-3.42,4.89c-2,.41-3.6-1.12-3.68-3.4a4.84,4.84,0,0,1,3.42-4.89C218,401.67,219.62,403.2,219.69,405.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.45,436c5.4,2.93,11.93,9.93,16.43,10.72a5.24,5.24,0,0,0,5.68-2.61s2,4.64,6.22,4.68c2.16,0,4.09-3.41,4.09-3.41s1.77,3.65,5.51,3.45c3-.15,4.47-3.57,4.47-3.57s3.34,2.71,6.32,1.58c6.05-2.29,7.43-27.86-1.77-32.32-4.29-2.07-4.29,4.19-4.29,4.19s-2.18-9-7.44-9.43S198.9,417,198.9,417s-2.19-8.71-7.69-8.59c-5.73.12-3.84,8.18-3.84,8.18s-3.55-5.9-7.74-4.84c-6.92,1.73.92,15.09-.72,20.64h-9.15Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.23,441c-5.36-2.33-7.93,1.49-13.52.76-6.22-.82-4.19-8.12,6.73-9.4l9.47,0Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.17,444.72a.07.07,0,0,0,.13,0c2.5-8.3,2.71-18.19-.15-26.42-.09-.27-.57-.24-.53.08C211.94,427.46,212.4,435.6,211.17,444.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.92,445.47c0,.09.15.12.18,0,2.53-8.57,2.46-19.71-2-28.82-.15-.31-.6-.44-.45-.06C201.17,422.88,202.07,437.27,200.92,445.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.84,416c3.89,8.9,4.54,18.15,3.85,27.74,0,.13.16.13.2,0,1.62-4.6,1.43-10.77.87-15.55a25.53,25.53,0,0,0-4.61-12.35C187.05,415.7,186.76,415.79,186.84,416Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.87,446.41c-3.37-1-6.09-3.45-8.92-5.36a4.13,4.13,0,0,0-1.11-.52,3.53,3.53,0,0,0-1.2.06c-.84.15-1.67.4-2.52.62A36.49,36.49,0,0,1,165,442.3a10.26,10.26,0,0,1-2.71,0,4.29,4.29,0,0,1-2.48-1.3,3.56,3.56,0,0,1-.72-1.23,3.38,3.38,0,0,1-.24-1.41A3.91,3.91,0,0,1,160,435.8a11.92,11.92,0,0,1,4.62-2.62,14.93,14.93,0,0,1,5.16-.84,16.45,16.45,0,0,0-5,1.21,11.28,11.28,0,0,0-4.28,2.68,3.27,3.27,0,0,0-1,2.12,3.13,3.13,0,0,0,.82,2.14,3.46,3.46,0,0,0,2.08,1,9.49,9.49,0,0,0,2.5.06,37.68,37.68,0,0,0,5.08-1c.85-.2,1.7-.4,2.59-.53a4.06,4.06,0,0,1,1.39,0,4.48,4.48,0,0,1,1.24.61c1.47,1,2.76,2.15,4.17,3.17A19.16,19.16,0,0,0,183.87,446.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.53,405.4l-36.76,1s19.29-34.77,30-47.72c11.13-13.49,18.77-12.56,14.81,10.26A362.88,362.88,0,0,1,131.53,405.4Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.66,400.3c.92-.12,1.86-.12,2.79-.15l2.86-.13c1.93-.08,3.87-.13,5.8-.17,3.86-.08,7.73-.17,11.59-.19,1.07,0,2.13,0,3.19,0s2.23.13,3.35.16c.07,0,.06.1,0,.1-.95.05-1.91.18-2.86.23s-2,.1-3,.13c-1.93.05-3.86.1-5.8.12-3.8.05-7.61.12-11.42.09l-3.18,0c-1.11,0-2.25,0-3.35-.07A.05.05,0,0,1,100.66,400.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.05,388.23a11.12,11.12,0,0,0,1.53-4s0,0,0,0a22.13,22.13,0,0,1-1.41,3.54c.11-.51.21-1,.31-1.53.36-1.84.74-3.69,1-5.55,0,0,0,0,0,0-.85,3.17-1.56,6.38-2.34,9.57s-1.56,6.47-2.33,9.71c-.42,1.77-.85,3.54-1.23,5.31-.6.07-1.07.06-1.59.12-.15,0-.16.26,0,.26a10.27,10.27,0,0,0,2-.07C133.61,399.9,134.88,394.06,136.05,388.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.84,364.53c-4.61.73-11.86-6.77-14.51-12.61-.18-.41.71-4.41,1.57-9.34.51-3,1-6.33,1.24-9.41l19,6.15A49,49,0,0,0,154.35,351a6.61,6.61,0,0,0,0,1.27c0,.06,0,.13,0,.21C154.61,354.93,154.3,363.82,149.84,364.53Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.47,333.61c.25,4.12,1.93,17.76,12.93,18.84a11.33,11.33,0,0,0,2,0c0-.08,0-.14,0-.2a6.82,6.82,0,0,1,0-1.29,49.41,49.41,0,0,1,2.75-11.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.13,308.05c-3.64,6.2-4.7,26.35-1,31.79C145.56,347.72,156.7,351,164,344c7.05-6.81,8-33.09,3.6-38.27C161.13,298.09,146.49,298.89,141.13,308.05Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.66,324.58c0-.05-.11.06-.11.12,0,1.35-.31,2.91-1.56,3.28,0,0,0,.08,0,.08C156.51,327.94,156.84,325.87,156.66,324.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,323.09c-2.17-.29-2.6,4.08-.58,4.35S157.35,323.34,155.53,323.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.72,325.09s.1.07.09.13c-.18,1.34-.15,2.92,1,3.49a0,0,0,0,1,0,.07C164.35,328.43,164.33,326.34,164.72,325.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.06,323.79c2.19,0,1.94,4.43-.09,4.38S164.22,323.75,166.06,323.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,320.93a17.18,17.18,0,0,0,1.75-.43,2.88,2.88,0,0,0,1.7-.78.92.92,0,0,0,0-1.13,2.27,2.27,0,0,0-2.28-.46,3.36,3.36,0,0,0-2.08,1.26A1,1,0,0,0,154,320.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,321.76c-.59-.16-1.12-.41-1.69-.62a2.93,2.93,0,0,1-1.6-1,.91.91,0,0,1,.16-1.12,2.27,2.27,0,0,1,2.32-.21,3.34,3.34,0,0,1,1.93,1.48A1,1,0,0,1,168,321.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.42,336.82c.29.35.57.82,1.06.91a3.61,3.61,0,0,0,1.49-.2s.08,0,.05.07a1.82,1.82,0,0,1-1.79.57,1.45,1.45,0,0,1-.95-1.3C154.27,336.79,154.38,336.77,154.42,336.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.24,332.91a4.61,4.61,0,0,0,2.87,2.35,6.1,6.1,0,0,0,1.65.24,1.69,1.69,0,0,0,.32,0,1.56,1.56,0,0,0,.3,0,.33.33,0,0,0,.3-.27h0a.33.33,0,0,0,0-.14h0v-.12c.13-1,.19-2.63.19-2.63.36.22,2.21,1.29,2.24.74.16-4.53.35-9.57-.44-14.11a.13.13,0,0,0-.25,0c-.33,4.34.1,8.72-.17,13.09a8.43,8.43,0,0,0-2.11-.87c-.15,0,0,3.09-.14,3.55a.18.18,0,0,1,0,.05,6.46,6.46,0,0,1-4.63-1.95C156.28,332.72,156.17,332.8,156.24,332.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51,310.68a7.66,7.66,0,0,1-7.15,2.09,7.82,7.82,0,0,1-5.66-5.07.06.06,0,1,0-.11,0,7.72,7.72,0,0,0,5.62,5.64,7.89,7.89,0,0,0,7.44-2.56C164.72,310.72,164.6,310.59,164.51,310.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.42,293.7a8.25,8.25,0,0,0-8.81,2.51,11.35,11.35,0,0,0-2.41,5.11.06.06,0,0,0,.12,0,10.33,10.33,0,0,1,5.86-6.9A6.92,6.92,0,0,1,161,296.2a7.11,7.11,0,0,1,1.76,4.31.14.14,0,0,0,.27,0A7.16,7.16,0,0,0,158.42,293.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.57,303.16a9.2,9.2,0,0,0-3.57-5.23c-2.45-1.77-5.37-1.75-8.27-1.66-.07,0-.07.12,0,.12,2.46-.07,5,0,7.14,1.33a9.09,9.09,0,0,1,3.88,4.71,8.85,8.85,0,0,1-4.45,10.7,9,9,0,0,1-7.12.22c-.09,0-.17.09-.08.13a9,9,0,0,0,12.46-10.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.21,309s.9-6.11,2.66-7.85,5.32-1.86,5.32-1.86,2.52-5,7.51-4.91c4.48.09,7.14,4.28,7.14,4.28s6.7-5.56,13.43-1.46c6.38,3.9,4.63,14-2.13,16.67-4.75,1.88-10.65-2.65-10.65-2.65-.6,0-7,3.26-11.21-2.55,0,0-4.46,2.88-6.66.38C145.62,309.07,142.28,310.31,140.21,309Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.84,325.13c1.25-.74,3.95-5.7,5.17-7.77,1.11-1.87,1.91-9.79,2.24-13.74a14.26,14.26,0,0,0-4.13,4.43C139.22,311.29,138,318.36,137.84,325.13Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,324.77s-3-7.22-6.21-6.28-1.86,10.76,1.21,12.73a3.49,3.49,0,0,0,5-.84Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.75,321.29a.05.05,0,0,0,0,.09c2.14,1.46,2.9,3.9,3.27,6.34a1.92,1.92,0,0,0-2.69-1.13.07.07,0,0,0,0,.14,2.16,2.16,0,0,1,2.15,1.23,10.33,10.33,0,0,1,.69,2.1c.07.24.47.21.44-.05a.13.13,0,0,0,0-.06C140.3,327,138.89,322.29,135.75,321.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.93,
    y: 321.58,
    width: 42.12,
    height: 2,
    transform: "translate(-172.42 230.53) rotate(-45.16)",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 257,
    r: 58.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,316.48A59.48,59.48,0,1,1,309.48,257,59.54,59.54,0,0,1,250,316.48Zm0-118A58.48,58.48,0,1,0,308.48,257,58.54,58.54,0,0,0,250,198.52Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,324.62A67.62,67.62,0,1,1,317.62,257,67.69,67.69,0,0,1,250,324.62Zm0-133.24A65.62,65.62,0,1,0,315.62,257,65.69,65.69,0,0,0,250,191.38Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.08,241.57c11.35,22.74,25.71,47.33,38.92,51.06,12.57,3.55,36.51-27.5,44-35.69,2.71-3-19.75-19.44-23.18-16.86-6.45,4.87-18,18-20,17.62s-18.53-15.82-33.49-28.76C254.33,221.1,249.22,225.82,257.08,241.57Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9,261c2.81-2.33,17.27-15.85,19.85-19.88s9.19-16.16,6.31-18.46-5.1,1.11-5.1,1.11,2-5.57-1.14-7.61-6.39,3.35-6.39,3.35,1.61-5.86-1.64-7.68-5.63,4.17-5.63,4.17,1.72-5.29-1.59-5.66c-4-.45-6.05,9.67-9.24,13.9-.73,1-16.07,18.44-16.07,18.44Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.37,215.46c-1.54,7.43-3.51,10.42-8.7,15.8-.1.1,0,.28.15.18,5.56-4.81,8.56-8.2,8.92-15.92C343.75,215.14,343.45,215.11,343.37,215.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.54,218.89c-2.28,7.58-4.38,10.84-9.4,16.87-.07.09.06.22.14.14,5.43-5.51,8.34-9,9.63-16.83C351,218.71,350.65,218.54,350.54,218.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.69,224c-2.74,7.18-4.88,10.85-10.51,16.08a.14.14,0,0,0,.18.22c6.26-4.78,9-9.34,10.54-16.2C358,223.68,357.86,223.59,357.69,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.39,247.07s.66-9.49,1.86-13.6,11.34-17.75,14.42-15.73c4,2.61-.33,11.64-3,15.79,0,0,9.18,6,7.5,13.17S312.39,247.07,312.39,247.07Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.52,218.81c1.9,5-2,10.21-4.27,14.43a.44.44,0,0,0,.29.66c3.68,2.78,8.06,7.78,7.87,12.64a.11.11,0,0,0,.22,0c.91-5.19-3-10.45-7.21-13.24,2.42-4.29,6.08-9.69,3.15-14.54A0,0,0,0,0,329.52,218.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25,241.63l24.25,26.81s-26.79,28.81-39,25.49-35.88-36.2-42.89-57.49c-4.86-14.72,4.31-13.09,12.7-5.74s30.37,25.59,31.35,25.35S311.25,241.63,311.25,241.63Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.76,293.14a12.33,12.33,0,0,1-7.28.79c-12.23-3.32-35.88-36.2-42.89-57.49-3-9.13-.63-12,3.62-11.05C268.58,242,294.85,280.18,303.76,293.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.37,272.64c-3.52-3.7-17.36-19.36-20.12-22.95-.19-.25-.08-.43.16-.2,10.8,10.84,16.83,19.2,20.1,23C327.59,272.59,327.45,272.74,327.37,272.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.57,305.35a67.39,67.39,0,0,1-77.65-4.06c3.68-19.14,12.73-51.8,31.47-73.32,5.23-6,19.48-4.25,21.14-1.84C272.72,242.38,282.64,284.77,286.57,305.35Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.18 316.48 325.38 318.98 336.9 259.72 294.7 257.22 283.18 316.48",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.26 316.6 327.46 319.1 338.98 259.85 296.78 257.34 285.26 316.6",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.81,285.94a4.58,4.58,0,0,1-4.7,3.84,3.72,3.72,0,0,1-3.51-4.33,4.6,4.6,0,0,1,4.71-3.84A3.7,3.7,0,0,1,317.81,285.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.17,240.64c-8.9,18.36-27.69,60-18.75,67.34,14.69,12,46.71,19.29,56.55,20.48,4.25.51,13.64-31.34,9.41-33.1-5.07-2.11-36.33-8.54-36.72-9.94s1.59-22.56.65-38.72C241.14,226.64,234.89,233,231.17,240.64Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.31,295.85s11.69-5.74,19.51-9.13c4.36-1.9,12.13-4.47,16-4.4,5.74.11,29.7,4.25,28.82,10.08-.8,5.28-20.93-.89-20.93-.89s20.87,4.43,18.74,10.61-23.94-3.82-23.94-3.82,21.33,5,18.13,11.06c-2.42,4.55-22.69-3.39-22.69-3.39s18.31,4.45,16,9.24c-2.53,5.29-21.7-.86-21.7-.86-7.86,11.19-15.89,13.89-22.28,14.11C267.48,328.51,263.31,295.85,263.31,295.85Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.55,289.76c15.61,2.09,22.63,7.9,22.41,7.78-5.14-2.75-13.78-5.21-16.2-5.86s-3.82-1.18-6.24-1.83C300.46,289.83,300.49,289.75,300.55,289.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.06,298.22a53.49,53.49,0,0,1,18.32,5c.22.12.12.18-.12.1-3.06-.91-15.13-4.26-18.22-5C297,298.28,297,298.22,297.06,298.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.57,305.31a39.75,39.75,0,0,1,14.07,4.27c.22.11.06.2-.18.13-4.65-1.51-8.29-2.73-13.92-4.24C293.45,305.45,293.47,305.29,293.57,305.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.59,292.38l-10.4,38S215.25,316,210.56,306.55s14.47-57.8,21-68.13,9.84-7.13,11.37,3.1-1,43.34-.69,43.9S268.59,292.38,268.59,292.38Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.61,269.92q.18-3.71.32-7.42c0-1.28.09-2.57.15-3.85l.09-1.78c0-.29.06-.59.06-.88a4.22,4.22,0,0,1,.09-1.18c0-.07.11-.07.12,0,0,.67.13.38.09.9a11.22,11.22,0,0,0,0,1.16c0,.59,0,1.18,0,1.77,0,1.22,0,2.43,0,3.64,0,.16,0,.32,0,.48a.59.59,0,0,0,0-.13c.22-1.35.45-2.7.68-4.05,0-.06.1,0,.1,0-.08,1.36-.2,2.72-.4,4.07-.12.78-.29,1.56-.45,2.33,0,1.62-.07,3.24-.13,4.86-.19,5-.4,10.07-1,15.06,2.22.58,4.47,1.07,6.68,1.66s4.45,1.21,6.66,1.83,4.44,1.23,6.64,1.89l3.15,1c1.14.36,2.25.84,3.39,1.17.12,0,.05.2-.07.17-1.19-.32-2.42-.48-3.62-.77s-2.11-.5-3.16-.77c-2.23-.57-4.45-1.18-6.68-1.78s-4.44-1.21-6.66-1.84-4.38-1.37-6.59-2a.2.2,0,0,1-.15-.13.25.25,0,0,1-.16-.25C242,280,242.36,275,242.61,269.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.61,309.07c.78-2.76,4-13.77,5-16.44,0,0,.09,0,.08,0-.46,2.74-3.33,13.7-4.11,16.46a156.78,156.78,0,0,1-5.18,16.4c0,.09-.2.07-.18,0C251.33,319.91,253.06,314.51,254.61,309.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.54,244.17s-13.42-10.28-21.17-9.07l-5.88,6.66s-2.08,1-2.92-.32c-2.07-3.19-3.4-11.37,3-17.55,5.88-5.67,19.28-6.28,28.39-5,8.76,1.21,14,5.63,12.11,11.48S256.54,244.17,256.54,244.17Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.08,241.47s8.89-8.13,9.39-12.37-8.22-7.18-13.73-8.08c-8.54-1.39-14.09-.18-18.18,4.78S257.08,241.47,257.08,241.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.08,241.47s-11.6-15.12-23.81-15.27l2.1,8.9s7.17-.85,21.17,9.07Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.16,235.66a15.39,15.39,0,0,1,6.55.08,28.66,28.66,0,0,1,6.24,2,49.78,49.78,0,0,1,5.83,3.06l2.76,1.81,2.69,1.93.3.21.29-.19a56.58,56.58,0,0,0,6-4.69,30.93,30.93,0,0,0,2.7-2.67,20.34,20.34,0,0,0,2.29-3,33.81,33.81,0,0,1-5.43,5.2c-1,.78-2,1.52-3,2.24s-2.06,1.45-3.1,2.11l.58,0-2.7-2c-.92-.63-1.87-1.24-2.81-1.85s-2-1.12-2.94-1.64-2-1-3.08-1.39a26.7,26.7,0,0,0-6.51-1.76c-.56-.09-1.12-.11-1.68-.16s-1.13,0-1.69,0A9.63,9.63,0,0,0,232.16,235.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.49,241.76a36.8,36.8,0,0,0,5.88-6.66,33.34,33.34,0,0,0-3.14,3.15A32.1,32.1,0,0,0,229.49,241.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.55,238.22a66.6,66.6,0,0,0-.81,11.49c0,2.68,1.35,12.26,4.32,11.83S253,255,252,250s.24-8.8.33-11.84Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.55,238.22a66.6,66.6,0,0,0-.81,11.49c0,2.68,1.35,12.26,4.32,11.83S253,255,252,250s.24-8.8.33-11.84Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M262.42,237.27a60.8,60.8,0,0,1,2.52,10.13c.4,2.4.73,11.17-2,11.25s.83-6.13.93-10.79-1.6-7.83-2.15-10.53Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M262.42,237.27a60.8,60.8,0,0,1,2.52,10.13c.4,2.4.73,11.17-2,11.25s.83-6.13.93-10.79-1.6-7.83-2.15-10.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M239.88,203.39a35.64,35.64,0,0,1-.22,6.43c-.43,1.66-4.15,3.39-4.15,3.39s4.24,1.51,5.45,1.22,3.15-3.38,3.15-3.38-1.79,4.95-3.51,5.21c-1.08.16,2.62.2,2.62.2a5,5,0,0,0,3.23-1.5C247.71,213.54,239.88,203.39,239.88,203.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.38,238.16c-4.51,1.21-12.5-5.51-15.74-11-.22-.38.26-4.46.6-9.45.19-3,.34-6.4.25-9.49L264,212.34a49.47,49.47,0,0,0-1.54,11.91,7,7,0,0,0,.17,1.26c0,.06,0,.13,0,.21C263.13,228.12,263.74,237,259.38,238.16Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.46,224.24a7.33,7.33,0,0,0,.14,1.1C253,224,247.43,219,244.4,214.78c.1-2.19.16-4.46.1-6.59L264,212.34A49.67,49.67,0,0,0,262.46,224.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.63,186.55c-1.46,7,4,26.47,9.24,30.43,7.64,5.74,19.25,5.29,23.9-3.69,4.5-8.7-3-33.9-8.82-37.41C255.4,170.72,241.79,176.16,239.63,186.55Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,196.85s-.09.09-.07.14c.4,1.3.64,2.86-.43,3.62,0,0,0,.09,0,.07C258.35,200.08,258,198,257.42,196.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.87,195.8c-2.15.42-1.16,4.69.84,4.3S257.68,195.45,255.87,195.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.32,194.57s.12,0,.13.09c.26,1.33.79,2.82,2.09,3,0,0,0,.07,0,.08C266,197.85,265.36,195.87,265.32,194.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.18,192.91c2.09-.66,3.25,3.58,1.31,4.18S264.43,193.46,266.18,192.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.73,194.24a15,15,0,0,0,1.52-1c.58-.38,1.08-.62,1.36-1.28a.92.92,0,0,0-.4-1.06,2.31,2.31,0,0,0-2.31.29,3.31,3.31,0,0,0-1.56,1.87A1,1,0,0,0,253.73,194.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33,190.38c-.61,0-1.19,0-1.8,0a2.92,2.92,0,0,1-1.83-.4.93.93,0,0,1-.2-1.11,2.29,2.29,0,0,1,2.13-.94,3.31,3.31,0,0,1,2.3.79A1,1,0,0,1,267.33,190.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.74,209.1c.39.24.8.59,1.29.52a3.57,3.57,0,0,0,1.35-.67s.09,0,.07.06a1.82,1.82,0,0,1-1.51,1.11,1.47,1.47,0,0,1-1.32-.93C259.59,209.12,259.68,209.07,259.74,209.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.21,204.81a4.63,4.63,0,0,0,3.47,1.31,6.16,6.16,0,0,0,1.64-.3,2.09,2.09,0,0,0,.3-.11l.28-.11a.34.34,0,0,0,.2-.36h0s0-.09-.05-.13h0l0-.12c-.21-1-.67-2.55-.67-2.55.42.1,2.52.51,2.36,0-1.29-4.35-2.72-9.19-4.92-13.24a.12.12,0,0,0-.23.09c1.07,4.23,2.88,8.24,4,12.47a8.2,8.2,0,0,0-2.27-.16c-.14.08.94,2.94,1,3.41a.12.12,0,0,1,0,.05,6.4,6.4,0,0,1-5-.37C260.19,204.61,260.1,204.73,260.21,204.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.61,205.61a5.59,5.59,0,0,1-1.85,2.08,2.49,2.49,0,0,1-1.46.36C260.18,208,260,207,260,206.12a5.82,5.82,0,0,1,.24-1.37A7.11,7.11,0,0,0,264.61,205.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.76,207.69a2.49,2.49,0,0,1-1.46.36C260.18,208,260,207,260,206.12A2.56,2.56,0,0,1,262.76,207.69Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.25,204.54c3.39-1.66,3-14,3-14l1.87,6.46a16.07,16.07,0,0,0,3.11-5.9,11.83,11.83,0,0,0-.88-6.55s4.7,3.43,9.47,3.82c1.76.14,14.11-2.15,14-2.91-.41-2.29-6.76-9.59-10.25-11.15-4-1.79-9.55-3.22-16.42.93s-7.95,9.25-8.38,13.13S241,205.15,242.25,204.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.33,202.27s-5.17-5.88-7.89-4,1.68,10.78,5.22,11.67a3.48,3.48,0,0,0,4.42-2.38Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.76,200.82s0,.08,0,.09c2.49.7,4,2.77,5.12,5a1.91,1.91,0,0,0-2.91-.2c-.06.05,0,.14.08.12a2.13,2.13,0,0,1,2.42.48A9.64,9.64,0,0,1,244.8,208c.14.2.51,0,.4-.2l0-.05C244.9,204.75,242.06,200.76,238.76,200.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.38,172.34a28.65,28.65,0,0,0-8.32-.9c-3.13.17-12.63,2.68-14.58,5s-.9,11.54-.72,12.88,2.24,9.26,5.51,10.67,1-12.29,4.8-17.65S255.38,172.34,255.38,172.34Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.38,172.35s-9.55,4.66-13.31,10-1.54,19.05-4.81,17.65c-1.43-.62-2.29-1.77-3.21-3.81-.12-4.1.36-10.58,2.9-15.47,2.37-4.58,7.36-7.59,13-9.29A32.43,32.43,0,0,1,255.38,172.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.54,208c-.4-3.69,1.51-14.09,4.36-20.38s13.66-11.63,15.27-11.83c3.91-.49,5.43.44,6,0s-4-2.63-5.17-3.08-4.42-1.46-6.09-1.11S242,174.84,239.07,180s-6,18.48-4.46,21.48c.38.72,1.48,1,2,2,.68,1.34,1.28,2.92,1.89,3.84C239,208,239.58,208.3,239.54,208Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.34,184.94a18.32,18.32,0,0,1-2.85-1.39,13.74,13.74,0,0,1-2.58-1.9c0-.05-.14,0-.09.08a10.47,10.47,0,0,0,2.43,2.22,8.89,8.89,0,0,0,3,1.19C244.41,185.16,244.44,185,244.34,184.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.84,204.35c-.15-.24-.36-.44-.53-.67a4.48,4.48,0,0,1-.51-.84,9,9,0,0,0-.73-1.69A6.72,6.72,0,0,0,236,200.1a2.47,2.47,0,0,1-1-1.34c0-.08-.14-.06-.12,0,.19,1.1,1.08,1.75,1.73,2.58a11.84,11.84,0,0,1,.85,1.8,2.86,2.86,0,0,0,1.23,1.34C238.78,204.53,238.9,204.44,238.84,204.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,200.2c-.42-.36-.86-.66-1.25-1a12.07,12.07,0,0,1-1-1.22c-.31-.42-.59-.86-.9-1.28s-.78-1-1.12-1.49c0-.07-.14,0-.09.08.35.54.6,1.14.93,1.69a12.8,12.8,0,0,0,1,1.35,7.93,7.93,0,0,0,1.09,1.15,4.09,4.09,0,0,0,1.37.83S239.41,200.22,239.38,200.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.05,196.4a10.57,10.57,0,0,1-2.39-1.87c-.68-.72-1.32-1.49-1.94-2.25,0-.06-.14,0-.11.06a13.46,13.46,0,0,0,1.76,2.53,7.11,7.11,0,0,0,1.14,1,6.76,6.76,0,0,0,1.48.66C240.05,196.54,240.11,196.44,240.05,196.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.86,192.74a3.74,3.74,0,0,1-1.14-.8q-.58-.52-1.14-1.08c-.35-.36-.72-.7-1.07-1.06a3.55,3.55,0,0,1-.9-1.21.06.06,0,0,0-.11,0,3.64,3.64,0,0,0,.67,1.35,9.38,9.38,0,0,0,1.09,1.27,12.69,12.69,0,0,0,1.24,1.07,2.41,2.41,0,0,0,1.32.59C240.91,192.9,241,192.77,240.86,192.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.11,188.23c-.4-.27-.79-.54-1.17-.84s-.73-.61-1.08-.93-.76-.67-1.11-1c-.05-.06-.13,0-.09.08a9.7,9.7,0,0,0,.91,1.2,13,13,0,0,0,1.09,1,10.09,10.09,0,0,0,1.2.86,3.74,3.74,0,0,0,1.33.61.08.08,0,0,0,.07-.14A7.26,7.26,0,0,0,241.11,188.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.74,182.36c-.44-.38-.87-.75-1.34-1.09a14.64,14.64,0,0,0-1.51-.94,15.18,15.18,0,0,0-3.17-1.39c-.06,0-.12.07-.05.11,2,1.16,4,2.23,6,3.41A.06.06,0,0,0,246.74,182.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.37,178.85a7.71,7.71,0,0,0-1.45-.95,16.3,16.3,0,0,0-3.43-1.16c-.07,0-.12.08,0,.11,1.06.46,2.12.89,3.15,1.41a15.29,15.29,0,0,1,1.49.82c.48.31.88.72,1.35,1,0,0,.09,0,.07-.06A4.41,4.41,0,0,0,248.37,178.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.14,176.87a7.59,7.59,0,0,0-1.36-1,9,9,0,0,0-2.94-1.07c-.07,0-.09.09,0,.11a18.51,18.51,0,0,1,2.84,1.36c.45.27.89.56,1.34.84s.84.67,1.3.91c0,0,.07,0,.05-.07A9.1,9.1,0,0,0,251.14,176.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,174.65c-.44-.24-.89-.45-1.34-.67a5,5,0,0,0-1.39-.48.06.06,0,0,0,0,.12c.85.46,1.7.93,2.54,1.41a12.34,12.34,0,0,1,2.07,1.69,0,0,0,0,0,0-.05A4.75,4.75,0,0,0,253,174.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.61,173.57a7.72,7.72,0,0,0-2.7-1.07c-.07,0-.1.1,0,.12a9.53,9.53,0,0,1,2.51,1.26,12.86,12.86,0,0,1,2.13,1.83s.1,0,.08,0A6.25,6.25,0,0,0,255.61,173.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.48,174.54a4.83,4.83,0,0,0-.41-.49,6,6,0,0,0-1-.84,13.39,13.39,0,0,0-2.35-1.21c-.08,0-.12.08,0,.11a10.74,10.74,0,0,1,2.23,1.28,9.43,9.43,0,0,1,1,.82c.14.15.28.3.41.46a3.57,3.57,0,0,0,.4.46s.11,0,.09-.06A1.62,1.62,0,0,0,259.48,174.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.7,174.34a9,9,0,0,0-.81-.7,10.55,10.55,0,0,0-.89-.59c-.32-.18-.64-.35-.95-.54-.08,0-.14.06-.06.11a6.09,6.09,0,0,1,.91.62l.82.63.82.64a8.46,8.46,0,0,0,.82.66c.05,0,.1,0,.07-.07A4.38,4.38,0,0,0,261.7,174.34Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 390.46,
    cy: 106.31,
    r: 58.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.46,165.79A59.48,59.48,0,1,1,450,106.31,59.55,59.55,0,0,1,390.46,165.79Zm0-118A58.48,58.48,0,1,0,449,106.31,58.55,58.55,0,0,0,390.46,47.83Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.46,173.93a67.63,67.63,0,1,1,67.63-67.62A67.7,67.7,0,0,1,390.46,173.93Zm0-133.25a65.63,65.63,0,1,0,65.63,65.63A65.7,65.7,0,0,0,390.46,40.68Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.12,34.3S381.29,26,395.29,35s11.27,46.28,8.92,51.92c0,0-27,11.58-50.18.37,0,0,13.93-26.86,12.43-40C365.59,39.68,371.12,34.3,371.12,34.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,57.37l-.26.75a56,56,0,0,1-4.38,9,33.22,33.22,0,0,1-5.82,7.52c-.06.06-.16,0-.1-.09a30,30,0,0,0,5.44-8,84,84,0,0,0,3.84-8.69A77.87,77.87,0,0,0,368.27,39c0-.13.23-.12.23,0,0,.9-.09,1.8-.16,2.69a.1.1,0,0,1,.14.12,88,88,0,0,1-3,17.66A66.65,66.65,0,0,1,358,75.57a82.63,82.63,0,0,1-5.79,8.13s-.09,0-.06-.06A85.85,85.85,0,0,0,365,57.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.41,33.44c12.81,8.49,16,24.38,15.43,38.36a66.3,66.3,0,0,1-1.68,12.79.07.07,0,0,1-.13,0,76.8,76.8,0,0,0,.43-22.25c-.91-6.93-2.54-14.12-6.27-20.22a26.86,26.86,0,0,0-7.88-8.46C392.19,33.55,392.29,33.36,392.41,33.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,96.53c-9.27,23.75-38.85,51.45-48.88,52.36-11.7,1.05-35.94-12.38-47.64-28.65-2.77-3.86,22-22.21,26.21-19.34,8.6,5.89,18.8,13.89,20.19,14,2.76.21,21.16-14.19,35.84-24.48C389.94,77.62,389.65,87.06,386,96.53Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,124.55s-10.72-11.07-11.86-21.49c-.78-7.22,0-26.35,17.31-39.3,4.11-3.08,12.16-4.54,7.26,2.92-3.48,5.3-7.29,7.61-8.75,11.06,0,0,10.45-.64,13.37,3.6A95.81,95.81,0,0,1,317.17,93a19.89,19.89,0,0,1-2.06,1.48s2.35,4.22.72,11.38Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.62,56.34l11.89,37.77a1.38,1.38,0,0,1-1.14,2.12l-19.79,1.15a3.22,3.22,0,0,1-2.86-1.88L294.83,57.72A1.37,1.37,0,0,1,296,55.61l19.78-1.15A3.19,3.19,0,0,1,318.62,56.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.27,56.45l11.89,37.78A1.37,1.37,0,0,1,327,96.34l-19.79,1.15a3.19,3.19,0,0,1-2.86-1.88L292.48,57.84c-.48-1.11,0-2.05,1.14-2.12l19.78-1.15A3.23,3.23,0,0,1,316.27,56.45Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,58.52a1.68,1.68,0,1,0,1.54-1.81A1.67,1.67,0,0,0,311,58.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.2,92.8c2.18-3.12,6.9-9.65,12.62-13.65,6.36-4.44,19.79-11.28,23-6.56,2.36,3.47-2.54,6.53-2.54,6.53s6.15-1.66,7.61,1.94c1.33,3.28-2.61,5.42-2.61,5.42s3.91-.36,4.58,3c.8,4.1-7.51,4.19-10.28,9C314,99.65,282.2,92.8,282.2,92.8Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.4,86.65c2.52-2.6,9.77-7,16.77-7.6.16,0,.25.1.11.14a76.27,76.27,0,0,0-16.84,7.52A0,0,0,0,1,298.4,86.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.07,92.94c2.41-2,10.09-6.25,17.19-6.59.16,0,.25.11.11.15A81.44,81.44,0,0,0,303.1,93S303,93,303.07,92.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,96.88c0,2.3-.06,4.53-.27,6.75-.1,1.11-.27,2.2-.48,3.3a28.84,28.84,0,0,1-.9,3.26,12.12,12.12,0,0,0,2.37-6.47,19,19,0,0,0,0-3.46A14.41,14.41,0,0,0,316,96.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.39,121.11l-18.27-20.4s14.53-12.46,25.06-17.17,12,2.08,7.38,12.32S373.39,121.11,373.39,121.11Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.39,121.11l-18.27-20.4s14.53-12.46,25.06-17.17,12,2.08,7.38,12.32S373.39,121.11,373.39,121.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,106.11l13.42,15s9.54-15,14.17-25.25c3.47-7.7,3.51-13.45-1.17-13.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.35,97.61c3.09,2.9,11.24,11,15.81,17.07,0,0-.11.16-.14.13-4.59-4.4-13-13.84-15.87-17C360.1,97.74,360.29,97.55,360.35,97.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.52,151.36A59,59,0,0,1,357.18,155C360,140.35,368.61,92.45,378,82.88c3.76-3.83,10.88-3.64,15.12-2.21,3.3,1.12,8.84,2.78,19.92,24.49C418.23,115.35,424.41,136.11,428.52,151.36Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.83,94.28c4.5.54,11.26-7,13.61-12.76.16-.4-.86-4.25-1.87-9-.6-2.88-1.2-6.1-1.54-9.08-.07-.61-18.17,6.66-18.17,6.66A47.68,47.68,0,0,1,375,81.34a7.36,7.36,0,0,1,0,1.24s0,.12,0,.2C374.86,85.15,375.49,93.76,379.83,94.28Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.89,63.66c-.3,5.13-2.05,17.65-12,19a10.81,10.81,0,0,1-1.92.11.67.67,0,0,1,0-.2,7.37,7.37,0,0,0,0-1.24,47.83,47.83,0,0,0-3.11-11.24S384.92,64.86,388.89,63.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.37,43.32c2,6.68-1.64,25.92-6.4,30.18-6.91,6.19-18.17,6.72-23.41-1.57-5.08-8,.09-33,5.41-36.9C375.8,29.33,389.42,33.46,392.37,43.32Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.43,50.93a16.2,16.2,0,0,1-1.65-.59,2.78,2.78,0,0,1-1.56-.92.91.91,0,0,1,.14-1.09,2.24,2.24,0,0,1,2.25-.22,3.27,3.27,0,0,1,1.89,1.43A1,1,0,0,1,377.43,50.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.9,48.72a16.76,16.76,0,0,0,1.74-.13,2.85,2.85,0,0,0,1.76-.47.9.9,0,0,0,.14-1.09,2.23,2.23,0,0,0-2.11-.81,3.26,3.26,0,0,0-2.19.87A1,1,0,0,0,363.9,48.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.41,67.43a2.06,2.06,0,0,1-1.23.56,3.6,3.6,0,0,1-1.33-.58s-.09,0-.07,0a1.79,1.79,0,0,0,1.52,1,1.42,1.42,0,0,0,1.23-1C373.56,67.44,373.47,67.39,373.41,67.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.76,63.29a4.45,4.45,0,0,1-3.31,1.43,5.47,5.47,0,0,1-1.6-.22,1.32,1.32,0,0,1-.3-.09l-.28-.09a.33.33,0,0,1-.2-.34h0a.65.65,0,0,1,0-.13h0l0-.11c.16-1,.53-2.51.53-2.51-.4.12-2.41.62-2.29.1a68.05,68.05,0,0,1,4.15-13.05.12.12,0,0,1,.23.07c-.84,4.15-2.4,8.12-3.32,12.27a7.62,7.62,0,0,1,2.2-.25c.14.06-.77,2.88-.8,3.34a.07.07,0,0,0,0,.05,6.23,6.23,0,0,0,4.83-.59C372.77,63.1,372.85,63.2,372.76,63.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.53,64.11a5.34,5.34,0,0,0,1.8,2,2.3,2.3,0,0,0,1.42.35c1.08-.08,1.28-1,1.24-1.87a5.49,5.49,0,0,0-.24-1.33A6.9,6.9,0,0,1,368.53,64.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.33,66.11a2.3,2.3,0,0,0,1.42.35c1.08-.08,1.28-1,1.24-1.87A2.47,2.47,0,0,0,370.33,66.11Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.54,53.05a2,2,0,0,1,.65-.77,1.38,1.38,0,0,1,1.07-.15,1.2,1.2,0,0,1,.8.75,2.1,2.1,0,0,1,.1,1,3.75,3.75,0,0,1-.13.58,2.52,2.52,0,0,1-.58,1.08,3.91,3.91,0,0,0,.2-.87,5.59,5.59,0,0,0,.05-.81c0-.55-.2-1.05-.61-1.14s-.83.12-1.14.58a8.78,8.78,0,0,0-.78,1.53A3.9,3.9,0,0,1,363.54,53.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.52,55.11a1.82,1.82,0,0,1,.53-.84,1.35,1.35,0,0,1,1.05-.3,1.26,1.26,0,0,1,.89.64,2.15,2.15,0,0,1,.23,1,4,4,0,0,1-.05.6,2.55,2.55,0,0,1-.43,1.14,3.88,3.88,0,0,0,.08-.89,4.18,4.18,0,0,0-.07-.8c-.09-.55-.33-1-.75-1.06s-.81.24-1.05.73a8,8,0,0,0-.57,1.63A3.85,3.85,0,0,1,373.52,55.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.57,61.25c-1-1-2-7.55-2-7.55s-11.91-5.47-12.75-16.56c0,0-5.73,6.93-10.92,8.08,0,0,.84-11.86,11.38-12.84,0,0,10-3.66,18.13,6.55s-.69,22.73-.69,22.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.21,35.07a10.46,10.46,0,0,0,.06,5.55,19.26,19.26,0,0,0,2,5.16,17.67,17.67,0,0,0,3.43,4.49,22.07,22.07,0,0,0,5.56,3.28c.06,0,0,.13-.05.11a25.29,25.29,0,0,1-5.92-3.15A17.6,17.6,0,0,1,375.5,46a14.09,14.09,0,0,1-2.19-5.49A12,12,0,0,1,374,35C374.05,34.88,374.26,34.94,374.21,35.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.15,58.77s4.51-6.11,7.29-4.49-.72,10.57-4.07,11.72a3.37,3.37,0,0,1-4.47-1.93Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.38,56.82a0,0,0,0,1,0,.09c-2.35.88-3.63,3-4.54,5.22a1.87,1.87,0,0,1,2.8-.44.07.07,0,0,1-.07.12,2.08,2.08,0,0,0-2.3.67,9.76,9.76,0,0,0-1.14,1.82c-.12.2-.49.08-.41-.15l0-.06C387.77,61.13,390.18,57,393.38,56.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.25,69.92a2.6,2.6,0,0,0,2.57-.13,3,3,0,0,1-.33,2.27l-.05-.8a5.36,5.36,0,0,1-.88,2.49,3.11,3.11,0,0,1-.72-1.6l.05,1A3.78,3.78,0,0,1,371.25,69.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.59,102.52c-5.06,31-17.67,51.05-23.57,52-15.88,2.62-42.72-23.34-50.73-29.44-3.24-2.46,23.17-24.56,26.29-21.53,7.36,7.12,17.25,18.31,17.77,18.43,1,.25,4.78-6.79,17.46-26.7C400.07,79.2,404.65,89.86,402.59,102.52Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.59,73.73c-2.2,3.34,6.5,8,6.5,8a7.33,7.33,0,0,0-4.7,1.74c-2.23,2.07,0,6.47,0,6.47a9.08,9.08,0,0,0-4.67,2.62c-1.94,2.19-.29,7-.29,7a8.28,8.28,0,0,0-2.65,4.9c-1,8.45,17.45,20.55,23.45,22.88l24.21-21.87s-9-20.08-16.3-25.27C335.11,77.33,316.94,68.62,313.59,73.73Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23,81.73c5.21,1.57,10,4.39,14.66,7.16a.09.09,0,0,1-.1.15c-4.57-2.8-10-4.45-14.67-7.07C320,81.9,320.08,81.69,320.23,81.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.76,89.73A13.91,13.91,0,0,1,319,91.57q1.63,1.09,3.24,2.25c2.14,1.53,4.25,3.11,6.3,4.76.09.07,0,.23-.1.16q-3.19-2.3-6.48-4.46l-3.32-2.12A17,17,0,0,1,315.57,90,.19.19,0,0,1,315.76,89.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.55,99.63a9.69,9.69,0,0,1,2.81,1.82c1,.72,1.93,1.43,2.9,2.14,1.93,1.42,3.87,2.83,5.85,4.18.1.07,0,.23-.1.16-2-1.36-4.06-2.69-6.07-4.07l-2.95-2a9.36,9.36,0,0,1-2.51-2.08A.07.07,0,0,1,310.55,99.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.55,142.26c-3.22-2.28-6.37-4.64-9.49-7-1.56-1.2-3.09-2.43-4.61-3.69s-3-2.55-4.45-3.92l.1.06a81.46,81.46,0,0,1-8.76-4.88,62.09,62.09,0,0,1-8-6,23.22,23.22,0,0,1-6.19-8,9.75,9.75,0,0,1-.67-5.16,6.15,6.15,0,0,1,2.92-4.37l-.23.58a12.9,12.9,0,0,1-.7-3.28,6.88,6.88,0,0,1,.52-3.39,5.07,5.07,0,0,1,1-1.42,6.35,6.35,0,0,1,1.35-1.08,6.67,6.67,0,0,1,3.27-1l-.33.63a9.3,9.3,0,0,1-1.18-3,4.41,4.41,0,0,1,.5-3.22,5.27,5.27,0,0,1,2.56-2,9.66,9.66,0,0,1,3.1-.62l-.12.52a26.4,26.4,0,0,1-3.34-2.15,13.18,13.18,0,0,1-2.83-2.8,4,4,0,0,1-.75-1.87,2.49,2.49,0,0,1,.62-1.89,4.37,4.37,0,0,1,3.68-1.12,4.31,4.31,0,0,0-3.54,1.23,2.29,2.29,0,0,0-.52,1.75,3.88,3.88,0,0,0,.77,1.72A12.39,12.39,0,0,0,317,79.47a28.94,28.94,0,0,0,3.33,2l.89.46-1,.06a9.19,9.19,0,0,0-2.88.64,4.69,4.69,0,0,0-2.22,1.76,3.74,3.74,0,0,0-.34,2.72,8.66,8.66,0,0,0,1.12,2.68l.37.58-.71,0a6.27,6.27,0,0,0-2.83.92,5.5,5.5,0,0,0-1.16.94,4.62,4.62,0,0,0-.85,1.2,6,6,0,0,0-.41,3,11.89,11.89,0,0,0,.66,3l.14.37-.36.21a4.92,4.92,0,0,0-1.59,1.56,6,6,0,0,0-.8,2.15,8.79,8.79,0,0,0,.65,4.62,22.74,22.74,0,0,0,5.9,7.69,60.88,60.88,0,0,0,7.89,6,95.44,95.44,0,0,0,8.6,5l.06,0,0,0c2.77,2.75,5.81,5.27,8.83,7.77S346.46,139.82,349.55,142.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.58,103.57c1,.83,2,1.72,2.95,2.63s1.88,1.83,2.8,2.77,1.81,1.9,2.68,2.89,1.73,2,2.53,3c-1-.84-2-1.73-2.94-2.63s-1.89-1.83-2.81-2.77-1.81-1.9-2.68-2.89S355.38,104.62,354.58,103.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.48,127.67l-24.37-12.51s9.11-16.83,17.25-25,12-2.36,11.3,8.86S399.48,127.67,399.48,127.67Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.48,127.67l-24.37-12.51s9.11-16.83,17.25-25,12-2.36,11.3,8.86S399.48,127.67,399.48,127.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.46,110.43c3.93,1.61,14.45,6.29,20.87,10.28,0,0,0,.19-.08.17-5.85-2.46-17.14-8.25-20.9-10.21C379.28,110.64,379.39,110.4,379.46,110.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.68,
    y: 184.43,
    width: 73.26,
    height: 2,
    transform: "translate(-33.54 292.69) rotate(-46.44)",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 111.54,
    cy: 178.87,
    r: 58.98,
    transform: "translate(-88.58 245.1) rotate(-76.37)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.54,238.35A59.49,59.49,0,1,1,171,178.87,59.56,59.56,0,0,1,111.54,238.35Zm0-118A58.49,58.49,0,1,0,170,178.87,58.56,58.56,0,0,0,111.54,120.38Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.54,246.49a67.63,67.63,0,1,1,67.62-67.62A67.71,67.71,0,0,1,111.54,246.49Zm0-133.25a65.63,65.63,0,1,0,65.62,65.63A65.7,65.7,0,0,0,111.54,113.24Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.45,102.62s9.73-10.6,22.39-6.69c15.79,4.87,16.35,47.74,18.2,55.61s8.64,9.89.94,17.08-18.58,9.59-29.7,9.38S74.74,173.1,73,168.18c-1-3,1.32-5.94,1.69-11C74.93,154.24,67.42,104.5,82.45,102.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,162.1c.08-3.39.94-6.64.84-10.08s-1-23-1.32-26.39c-.88-8.57-.25-21.84,10.81-22.75a.17.17,0,0,1,0,.33c-13.6,2.56-10.14,21.79-9,40.9a78.37,78.37,0,0,1-.42,14.2c-.84,6-.05,11.13,4.76,15.25a.11.11,0,0,1-.14.17A14.38,14.38,0,0,1,72.15,162.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.61,102.25c5.56-4.79,12.2-8.89,19.87-6.8,6.64,1.8,11.06,7.69,13.37,13.76,3.23,8.49,3.38,34.21,6.92,42.6,1.25,3,4.15,6,4.09,9.42-.06,3-2.39,4.1-5,4.83-.14,0-.23-.16-.08-.2,6.35-2,4.3-6.36,2-10.51a39.15,39.15,0,0,1-3.54-9.15c-1.63-6.37-2.47-29.35-4.59-35.6-2.06-6.07-5.84-12.06-12.23-14.4-8-2.92-14.74,1.4-20.77,6.16C84.62,102.42,84.54,102.31,84.61,102.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.29,102.53c-2.74,2.15-11.17,1.11-14.37-3.28C64.5,93.2,72.18,83,79.83,86.5S85.41,100.87,83.29,102.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.55,88.5a15,15,0,0,0-3.4,6.41,5.62,5.62,0,0,0,2.35,6,13.39,13.39,0,0,0,3.16,1.66,16,16,0,0,0,3.48,1,12.39,12.39,0,0,0,7.15-1A10.7,10.7,0,0,1,76,104.46a15.21,15.21,0,0,1-3.77-.82,14.28,14.28,0,0,1-3.48-1.77,6.94,6.94,0,0,1-2.46-3.18,6.63,6.63,0,0,1-.08-4A12.51,12.51,0,0,1,70.55,88.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.06,235.32a5.67,5.67,0,0,1,.1-.57,5.85,5.85,0,0,0-.12.71C42.05,235.41,42.05,235.37,42.06,235.32Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.86,241a2.55,2.55,0,0,1-.33.17l0-.08h0l.34-.07Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,156.29c-19.9,20.18-44.94,62.61-40.27,71.21,5.2,9.58,32.91-18.7,32.8-20.35-.08-1.25,9.67-27,17.06-45.77S91.94,151.31,87,156.29Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.74,207.18c.84-2.75,14.11-36.74,17.9-47.49s.28-14.07-10.55-4.23-34.57,42.73-40,60.19c-5.22,16.81,3.43,16.81,14.85,9.06C71.32,218.36,79.74,207.18,79.74,207.18Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.74,207.18c.84-2.75,14.11-36.74,17.9-47.49s.28-14.07-10.55-4.23-34.57,42.73-40,60.19c-5.22,16.81,3.43,16.81,14.85,9.06C71.32,218.36,79.74,207.18,79.74,207.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,227.64A67.47,67.47,0,0,1,72,226.35l.15-.89L75,204.31s-6.72-11.75-2.81-20.17c2-4.26,19.25-30.82,26.54-36.09,6.82-5,16.72.35,20.41,4.23C132.14,166,138.86,192.15,143.82,227.64Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,227.64A67.47,67.47,0,0,1,72,226.35l.15-.89L75,204.31s-6.72-11.75-2.81-20.17c2-4.26,19.25-30.82,26.54-36.09,6.82-5,16.72.35,20.41,4.23C132.14,166,138.86,192.15,143.82,227.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.12,225.46q.52-5.31,1.15-10.61c.43-3.53.8-7.07,1.28-10.59l.08.32a23.72,23.72,0,0,1-3.9-9.73,23.21,23.21,0,0,1-.23-5.27,19.26,19.26,0,0,1,1.3-5.12,50.23,50.23,0,0,1,4.93-9.17A81,81,0,0,1,82.94,167c-2,2.79-3.92,5.68-5.7,8.61a59.1,59.1,0,0,0-4.6,9.17,18.32,18.32,0,0,0-1.19,4.88,24.35,24.35,0,0,0,.25,5,22.83,22.83,0,0,0,3.63,9.35l.11.16,0,.17c-.47,3.52-1,7-1.57,10.55S72.73,222,72.12,225.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.17,175.34a5.48,5.48,0,0,1,.24-1.4,12.56,12.56,0,0,1,.48-1.34c.2-.43.4-.85.64-1.26a10,10,0,0,1,.79-1.17,19.17,19.17,0,0,1-1,2.63C78,173.66,77.58,174.48,77.17,175.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.75,201.57a43.84,43.84,0,0,1,11.36,1.89c3.71,1,11.9,4.29,14,5.09a0,0,0,0,1,0,.09,73,73,0,0,1-7.89-2.38c-3.63-1.23-7.3-2.35-11-3.32a53,53,0,0,0-6.38-1.15C86.61,201.77,86.6,201.56,86.75,201.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,203.52a35.3,35.3,0,0,1,11.93,1.06s0,.09,0,.08c-2-.23-3.94-.46-5.93-.63s-4-.27-6-.4C79.91,203.62,79.92,203.53,80,203.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.75,227.5c4.48,6.41,16.67,7.63,47.08,13.59,4.21.82,18-27.31,13.57-28.43-5.6-1.4-27.65-5.61-29.3-5.72C64.17,206.06,43.71,223.15,46.75,227.5Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.32,211.28s12.88,1.94,19.33,5.06c8.64,4.18,14.39,11.34,16.61,14.49,4.64,6.57,11.33,25.66,6.17,28.54-4.68,2.61-10.53-17.25-10.53-17.25s9.31,19.27,3.1,21.38-11.68-21.33-11.68-21.33,9.12,20,2.37,21.17c-5.09.88-11.25-20.07-11.25-20.07s7.72,17.25,2.51,18.38c-5.74,1.25-12.64-17.73-12.64-17.73-13.71.64-20.5-4.66-24.88-9C79.37,233.87,101.32,211.28,101.32,211.28Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.11,235.25c1.18,2.23,2.38,4.47,3.36,6.79s1.86,4.68,2.61,7.08a42,42,0,0,1,2,9.62c-1-5.77-4.33-14.13-5.3-16.45s-1.83-4.68-2.8-7C130,235.23,130.09,235.2,130.11,235.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.67,238.62c1.38,2.9,2.85,5.73,4.1,8.7s2.17,5.86,3.2,8.89c.08.23-.07.2-.16,0-1.16-3-2.46-5.66-3.65-8.63s-2.27-6-3.56-8.91C121.58,238.6,121.65,238.57,121.67,238.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.91,240.2A71.79,71.79,0,0,1,119.16,254c.07.23-.12.16-.21-.07-1.66-4.62-2.93-8.25-5.19-13.64C113.72,240.19,113.86,240.11,113.91,240.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,211.28,77.36,241s-26.94-6.19-30.91-13.1c-2.62-4.55,17.67-23,33-20.82Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,211.28,77.36,241s-26.94-6.19-30.91-13.1c-2.62-4.55,17.67-23,33-20.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.16,211.85A26.59,26.59,0,0,1,79.45,207c.08,0,.08.14,0,.14-6.68-.19-15.71,3.31-18.23,4.83C61.15,212,61.1,211.9,61.16,211.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.07,236c2.76-3.42,5.69-6.69,8.64-9.95s5.88-6.53,8.91-9.72c1.71-1.8,3.41-3.62,5.19-5.36,0,0,.13,0,.09.08-2.75,3.41-5.68,6.7-8.59,10s-5.89,6.54-8.88,9.76c-1.69,1.83-3.41,3.62-5.18,5.36C70.16,236.21,70,236.08,70.07,236Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05,210.89a36.77,36.77,0,0,0-5-1.13c-1.68-.32-3.37-.61-5.06-.88-3.36-.54-10.41-2.06-16.62-2-.07,0,.28.33.35.33,3-.16,24.12,4.05,25.86,4.17a3.9,3.9,0,0,0-.19.35c0,.09,0,.2.15.14s.37-.33.57-.49A.25.25,0,0,0,104.05,210.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,154.13c25.46,22.21,45.49,49.65,44.19,56.51-2.42,12.77-19.24,13.57-21.79,10.81-10.31-11.17-21.19-32.81-33-57C102.84,142.91,115.57,146.82,124,154.13Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,154.13c25.46,22.21,45.49,49.65,44.19,56.51-2.42,12.77-19.24,13.57-21.79,10.81-10.31-11.17-21.19-32.81-33-57C102.84,142.91,115.57,146.82,124,154.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.15,216.46c-1.87-2.89-3.62-5.88-5.41-8.83s-3.55-5.92-5.28-8.91c-3.43-5.9-6.61-11.93-9.68-18-1.74-3.45-3.5-6.89-5.16-10.38-.05-.11-.23,0-.19.09q2.4,6.08,5.16,12l-.1-.13-1.23-1.67c-.79-1.11-1.54-2.25-2.26-3.41a.08.08,0,0,0-.14.09,38.49,38.49,0,0,0,2.79,4.55,20.45,20.45,0,0,0,1.59,2l.05,0q1.26,2.63,2.61,5.22c3.2,6.1,6.59,12.14,10.39,17.91,1.07,1.62,2.14,3.24,3.26,4.83s2.31,3.12,3.47,4.69C142.07,216.62,142.21,216.55,142.15,216.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.57,219c-4.82-6.93-2.38-20.7,2.92-53.74.73-4.57,35.43-4.93,34.9,0-.67,6.19-6.85,30.69-8.46,34.3C172.05,217.17,153.84,223.67,150.57,219Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,151.52c-1.34-10.51-3.3-13,.28-22.47,2.35-6.21-.61-10.38-5.78-5.8-8.45,7.5-9.57,21.42-8.57,26.36Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,112.91l-12.59,42.32c-.51,1.23.08,2.28,1.31,2.33l22.07.94a3.57,3.57,0,0,0,3.16-2.15L182.49,114c.51-1.24-.08-2.29-1.31-2.34l-22.07-.93A3.58,3.58,0,0,0,156,112.91Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.57,113,146,155.32c-.5,1.23.08,2.28,1.32,2.33l22.07.93a3.56,3.56,0,0,0,3.15-2.14l12.59-42.32c.51-1.24-.08-2.28-1.31-2.33l-22.07-.93A3.56,3.56,0,0,0,158.57,113Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.54,115.21a1.88,1.88,0,1,1-1.75-2A1.87,1.87,0,0,1,164.54,115.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.07,181.22s6.29-13.65,6-25c-.22-7.84-2.6-24.85-23.1-36.18-4.86-2.68-13.69-3.06-7.35,4.21,4.51,5.16,8.93,7.08,11,10.56,0,0-11.29.85-13.79,5.82a102.48,102.48,0,0,0-5.61,13.47,22.76,22.76,0,0,0,2.43,1.28s-1.9,4.86.9,12.3Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.63,148.78c-2.79-3-8.81-9.32-15.53-12.76-7.46-3.83-22.87-9.18-25.63-3.65-2,4.06,3.67,6.63,3.67,6.63s-6.83-.87-7.86,3.19c-.94,3.71,3.59,5.43,3.59,5.43s-4.24.18-4.45,3.93c-.26,4.5,8.66,3.38,12.34,8.17C155.58,160.8,188.63,148.78,188.63,148.78Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.38,144.57c-3.09-2.41-11.51-6.08-19.09-5.67-.18,0-.26.14-.1.17a82.37,82.37,0,0,1,19.15,5.57S170.41,144.6,170.38,144.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.3,152c-2.88-1.8-11.73-5.2-19.4-4.52-.17,0-.24.15-.09.17a87.91,87.91,0,0,1,19.46,4.43A0,0,0,0,0,166.3,152Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.94,176.43l-40.23,11.41s-8,26.38-2.93,33c5.46,7.07,30.79-3.89,35.83-19.3Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.94,176.43l-40.23,11.41s-8,26.38-2.93,33c5.46,7.07,30.79-3.89,35.83-19.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,197c4.5-1,8.93-2.28,13.36-3.55s8.87-2.53,13.27-3.91c2.48-.78,5-1.54,7.43-2.41.07,0,0-.14,0-.12-4.49,1-8.93,2.25-13.36,3.49s-8.87,2.53-13.29,3.86c-2.49.75-5,1.55-7.44,2.41C149.85,196.81,149.89,197,150,197Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.14,187.41c-.63.07-1.25.2-1.87.31a.27.27,0,0,0-.19.21c-.69,2.33-1.18,4.75-1.67,7.14s-.9,4.72-1.29,7.1c-.21,1.27-.4,2.55-.55,3.84a14,14,0,0,0-1.39,5c0,.09.14.1.15,0a17.45,17.45,0,0,1,1.19-4.48,31.35,31.35,0,0,0,.25,9.42s0,0,0,0c-.79-4.64.38-9.49,1.14-14.06.38-2.29.82-4.58,1.26-6.86s1-4.53,1.4-6.81c.53-.2,1.07-.4,1.58-.64C150.26,187.53,150.22,187.4,150.14,187.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.49,155.1s4.23,10.75,11.88,10.75c9.26,0,22.47-13.41,22.47-13.41s-8.42-8-19.25-6.39C93.44,147.38,87.49,155.1,87.49,155.1Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,146.88c-.21,1.33-5.82,10.26-11.81,10.42-2,0-2.69-10.59-2.69-10.59l-.23-.77-3.27-10.82,12.32-9.24,1.79-1.23s.69,3,1.53,6.78c0,.18.07.35.11.54s.11.41.15.61c.13.56.26,1.14.38,1.71s.19.86.27,1.32.17.92.26,1.38A72.33,72.33,0,0,1,111.12,146.88Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,144.86c-8.32,1.49-13.13-.47-15.62-2.23l-2.27-7.51,12.32-9.24,1.78-1.23s.7,3,1.53,6.78q.06.25.12.54c0,.21.11.42.15.62.13.56.26,1.13.38,1.71.09.43.18.86.26,1.32s.18.91.27,1.37C110.46,139.92,110.83,142.93,111,144.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06,117.38c3.75,19.48-7.5,23.92-11.7,24.72-3.81.73-16.89,2.73-22.63-16.26S84.87,99,93.5,96.83,113.32,97.9,117.06,117.38Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.39,113.65a12.44,12.44,0,0,1-1.37-.1,2.18,2.18,0,0,1-1.37-.36.7.7,0,0,1-.12-.86,1.75,1.75,0,0,1,1.65-.64,2.58,2.58,0,0,1,1.72.68A.75.75,0,0,1,113.39,113.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,116.64c.46-.11.86-.29,1.3-.44a2.24,2.24,0,0,0,1.24-.7.71.71,0,0,0-.11-.86,1.75,1.75,0,0,0-1.76-.2,2.58,2.58,0,0,0-1.49,1.1A.75.75,0,0,0,100,116.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.66,120.26c0-.05-.09.08-.08.13.23,1.33.28,2.9-.87,3.51,0,0,0,.09,0,.08C104.18,123.56,104.1,121.48,103.66,120.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.27,119c-2.18.15-1.72,4.49.29,4.35S104.09,118.91,102.27,119Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.44,119.35c-.35.29-.68.76-1.13.85s-1-.3-1.36-.7c0,0-.07,0-.07.06.08.83.48,1.65,1.39,1.68s1.33-.77,1.45-1.63C101.74,119.45,101.58,119.24,101.44,119.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.47,118.9c0-.05.11.06.12.11.11,1.35.46,2.87,1.73,3.18,0,0,0,.08,0,.08C111.81,122.23,111.36,120.2,111.47,118.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,117.37c2.14-.41,2.8,3.9.82,4.28S110.72,117.71,112.51,117.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45,117.51c.38.18.78.54,1.19.51s.75-.57,1-1.06c0,0,.07,0,.08,0,.15.82,0,1.72-.76,2s-1.34-.37-1.66-1.16C113.22,117.69,113.3,117.44,113.45,117.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.22,130.7c.34.3.69.72,1.18.73a3.49,3.49,0,0,0,1.43-.43,0,0,0,0,1,.06.07,1.82,1.82,0,0,1-1.67.83,1.44,1.44,0,0,1-1.13-1.13C105.07,130.7,105.17,130.66,105.22,130.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.26,125.2s.51,2,.62,2.92c0,.09-.21.15-.53.21h0a4.55,4.55,0,0,1-4.56-1.17.1.1,0,0,1,.13-.15,6.87,6.87,0,0,0,4.24.7c0-.27-1-3.35-.84-3.38a8.36,8.36,0,0,1,2.2.24c-.94-4.14-2.54-8.09-3.42-12.23a.13.13,0,0,1,.24-.09c2,4,3.16,8.76,4.25,13C112.69,125.8,110.66,125.32,110.26,125.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.63,125.88C86.87,125.82,87,119,87,119s6.53-.6,7.79-10.2a14.48,14.48,0,0,1-2.15,8s11.4-2.31,15.33-12.41c0,0-1.47,5.09-3.11,7,0,0,4.7-1.81,6.68-6,0,0,2.55,5.37,4.25,6.76,0,0-2.4-20.1-20.86-16.18,0,0-11.62,1.89-14.94,11.54S83.63,125.88,83.63,125.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.74,126.25s-4.94-5.72-7.58-3.89,1.53,10.42,4.94,11.3a3.35,3.35,0,0,0,4.28-2.26Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.42,124.79a0,0,0,0,0,0,.09c2.4.7,3.83,2.7,4.91,4.83a1.86,1.86,0,0,0-2.81-.22c-.06,0,0,.14.07.12a2.07,2.07,0,0,1,2.34.48,10.25,10.25,0,0,1,1.27,1.71c.13.2.49,0,.38-.18a.08.08,0,0,0,0-.05C86.3,128.63,83.6,124.76,80.42,124.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.81,241l-.33.08h0Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.16,234.75a5.85,5.85,0,0,0-.12.71c0-.05,0-.09,0-.14A5.67,5.67,0,0,1,42.16,234.75Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.16,234.75a5.85,5.85,0,0,0-.12.71c0-.05,0-.09,0-.14A5.67,5.67,0,0,1,42.16,234.75Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.32,244.41h0l-1,.24Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.16,234.75a5.85,5.85,0,0,0-.12.71c0-.05,0-.09,0-.14A5.67,5.67,0,0,1,42.16,234.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.56,
    y: 216.18,
    width: 2,
    height: 29.99,
    transform: "translate(-102.78 317.23) rotate(-70.62)",
    style: {
      fill: "#7E57C2"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedworldCuate);
export default __webpack_public_path__ + "static/media/Connected world-cuate.9c66b19834fe71c49ced218ba8f279bf.svg";
export { ForwardRef as ReactComponent };